// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:38:35.314Z
// Property: Cross Timber (ID: 6767906449165600)
// Collections: 16 amenities, 3 floorplans (live), 17 photos, 70 POIs, 5 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165600",
  "property_external_id": "x6tt70p",
  "property_zillow_url": "https://www.zillow.com/homedetails/10700-S-May-Ave-APT-424-Oklahoma-City-OK-73170/2082540917_zpid/",
  "property_apartments_url": "https://www.apartments.com/cross-timber-oklahoma-city-ok/x6tt70p/",
  "property_google_business_url": "https://www.google.com/maps/place/Cross+Timber/data=!4m2!3m1!1s0x0:0xb03916c43b4f713f?sa=X&ved=2ahUKEwj-rKbT97ySAxXyHEQIHeZ4Nf8Q_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": "https://www.linkedin.com/company/crosstimbercs",
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "cross-timber",
  "property_name": "Cross Timber",
  "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/cross-timber/",
  "property_domain": null,
  "property_address": "10700 S. May Ave.",
  "property_full_address": "10700 S. May Ave., Oklahoma City, OK, 73170",
  "property_address_1": "10700 S. May Ave.",
  "property_address_2": null,
  "property_address_city": "Oklahoma City",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73170",
  "property_address_country": "US",
  "property_address_county": "Oklahoma County",
  "property_neighborhood_address": "Lakeridge Run",
  "property_address_latitude": "35.3614",
  "property_address_longitude": "-97.56421",
  "property_email": "crosstimber@caseusa.com",
  "property_phone": "(405) 287-2987",
  "property_call_tracking_phone": "844-934-4381",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Cross Timber, where comfort meets community in Oklahoma City. Choose between spacious two and three-bedroom floor plans, all adorned with modern amenities—like a pool, fitness center, and pet play area. Enjoy social activities and online services while basking in luxury. Your perfect home awaits! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Cross Timber, the perfect apartment community nestled in the heart of Oklahoma City! With spacious two and three-bedroom floor plans designed to meet your every need, Cross Timber offers stylish living that combines comfort and convenience. Discover your ideal home featuring modern amenities, such as air conditioning, high-speed internet access, and luxurious quartz countertops.\n\nOur community is designed with your lifestyle in mind, boasting an array of amenities for leisure and socialization. Dive into relaxation at our shimmering pool, stay fit in our state-of-the-art fitness center, or unwind in the welcoming clubhouse. Enjoy the outdoors with our sundeck, picnic area, and well-equipped dog park, all within our gated, fenced lot providing peace of mind.\n\nAt Cross Timber, we prioritize your comfort and convenience. Our dedicated team includes on-site maintenance and a property manager, ensuring your living experience is seamless. With online services, 24-hour access, and planned social activities, making connections here is effortless. \n\nFor pet owners, our pet play area ensures your furry companions have plenty of space to roam and play. Additional features include ample storage space, bicycle storage, and wheelchair-accessible rooms, catering to all our residents’ needs. \n\nWhether you are looking to entertain in your eat-in kitchen or relax in your large bedroom, Cross Timber is where you will find the ideal balance of sophistication and comfort. Don’t miss out on making this community your new home! Find your new home today — browse our availability or schedule a tour to visit our exceptional community!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-d3c6-7076-bbe5-071edd09274a.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of apartment buildings and commercial storefronts in a suburban neighborhood.",
    "public_id": "019cfb3f-d3c6-7076-bbe5-071edd09274a",
    "storage_key": "property/6767906449165600/019cfb3f-d3c6-7076-bbe5-071edd09274a.webp",
    "width": 2048,
    "height": 1365
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "150",
  "property_year_built": "2015",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.66666666666667",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "350-450",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "breed restrictions apply",
  "property_pet_policy_description": "Up to 80lbs max",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://crosstimberokc.securecafe.com/onlineleasing/cross-timber/floorplans.aspx",
  "property_resident_portal_url": "https://crosstimberokc.securecafe.com/residentservices/cross-timber/userlogin.aspx",
  "property_apply_now_url": "https://crosstimberokc.securecafe.com/onlineleasing/cross-timber/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3e-af04-706f-a16b-61338677b4ad.webp",
  "property_primary_logo_media": {
    "alt_text": "Cross Timber Apartment Homes logo",
    "public_id": "019cfb3e-af04-706f-a16b-61338677b4ad",
    "storage_key": "property/6767906449165600/019cfb3e-af04-706f-a16b-61338677b4ad.webp",
    "width": 300,
    "height": 130
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-c4ac-74de-8735-47a322cfe0e4.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb3f-c4ac-74de-8735-47a322cfe0e4",
    "storage_key": "property/6767906449165600/019cfb3f-c4ac-74de-8735-47a322cfe0e4.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-e831-722c-a277-f1f86c4c59b9.webp",
  "property_mono_white_logo_media": {
    "alt_text": "White background with curved top and bottom edges",
    "public_id": "019cfb3f-e831-722c-a277-f1f86c4c59b9",
    "storage_key": "property/6767906449165600/019cfb3f-e831-722c-a277-f1f86c4c59b9.webp",
    "width": 300,
    "height": 130
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-fb14-747d-87ae-e813d0a38293.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Property Logo",
    "public_id": "019cfb3f-fb14-747d-87ae-e813d0a38293",
    "storage_key": "property/6767906449165600/019cfb3f-fb14-747d-87ae-e813d0a38293.webp",
    "width": 300,
    "height": 130
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#3d3d3f",
  "property_secondary_color": "#3d3d3f",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#eae0c8",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "929 - 1204",
  "property_sqft_min": "929",
  "property_sqft_max": "1204",
  "property_price_range": "1239 - 1579",
  "property_price_min": "1239",
  "property_price_max": "1579",
  "property_available_units": 8,
  "property_facebook_url": "https://www.facebook.com/CrossTimbersWagoner/",
  "property_instagram_url": "https://www.instagram.com/crosstimberapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJwQZJYwATsocRP3FPO8QWObA",
  "property_youtube_url": "https://www.youtube.com/shorts/6PbF9-Yqtgs",
  "property_yelp_url": "https://www.yelp.com/biz/crosswinds-apts-oklahoma-city",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cross Timber",
  "property_home_romance_title": "Embrace Life in Your Ideal Apartment Community Today",
  "property_home_amenities_blurb": "Welcome to Cross Timber in the heart of Oklahoma City, where vibrant living meets unmatched comfort. Our spacious two and three-bedroom apartments offer modern features like quartz countertops and walk-in closets, complemented by a resort-style pool, fitness center, and dog park. Experience a community designed for connection and convenience!",
  "property_home_floorplans_blurb": "Welcome to Cross Timber in vibrant Oklahoma City, where spacious two and three-bedroom apartments await. Embrace comfort and style in our thoughtfully designed floor plans tailored to your lifestyle. Browse our available homes today and find the perfect space to create cherished memories in your new community.",
  "property_home_gallery_blurb": "At Cross Timber in Oklahoma City, your perfect home awaits! Choose from spacious two and three-bedroom apartments featuring modern amenities like a sparkling pool, a state-of-the-art fitness center, and a pet-friendly environment. Enjoy the vibrant social scene and unbeatable convenience—picture yourself living here! Experience community living at its finest!",
  "property_home_neighborhood_blurb": "At Cross Timber in Oklahoma City, enjoy spacious two- and three-bedroom floor plans nestled near local gems like the Oklahoma City Community College and the vibrant Urban Air Trampoline and Adventure Park. With Buck Thomas Park and the Moore Public Library just moments away, your ideal lifestyle awaits. ",
  "property_home_reviews_blurb": "At Cross Timber in Oklahoma City, residents revel in a tranquil, clean oasis. With rave reviews like, “the complex is quiet, safe, and clean,” our welcoming community prioritizes comfort and convenience. Enjoy spacious apartments, friendly management, and a prime location just steps from everything you need. Join us today!",
  "property_neighborhood_blurb": "Nestled in the heart of Oklahoma City, Cross Timber offers more than just spacious two- and three-bedroom apartments. Enjoy easy access to educational institutions like Oklahoma City Community College and Mid-America Christian University. Outdoor enthusiasts can delight in nearby parks, while vibrant cultural spots like the 99s Museum of Women Pilots await your exploration. See what's around our community and uncover local favorites!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Cross Timber in Oklahoma City, elevate your lifestyle with spacious two and three-bedroom apartments featuring modern island kitchens and walk-in closets. Unwind by the sparkling pool, stay active in the fitness center, or socialize in the clubhouse. Experience the convenience of 24/7 access and on-site management tailored for you.",
  "property_applynow_blurb": "At Cross Timber in Oklahoma City, your perfect retreat awaits! Choose from spacious two or three-bedroom floor plans, each featuring modern comforts like quartz countertops and walk-in closets. Enjoy resort-style amenities including a sparkling pool, fitness center, and dog park. Find your new home and lease online today!",
  "property_contactus_blurb": "At Cross Timber in Oklahoma City, choose from spacious two and three-bedroom floor plans designed for comfort and style. Each layout offers modern touches and ample space, perfect for your lifestyle. Have questions? Contact our leasing team today to learn more about making Cross Timber your new home!",
  "property_faqs_blurb": "At Cross Timber in Oklahoma City, our spacious two and three-bedroom floor plans offer the perfect blend of comfort and style. Have questions? Our FAQs page is your gateway to discovering everything about our vibrant community. Dive in and find the answers you need to make Cross Timber your new home!",
  "property_floorplans_blurb": "At Cross Timber in Oklahoma City, you’ll find spacious two and three-bedroom apartments designed for modern living. Each floor plan offers a blend of comfort and style, perfect for any lifestyle. Browse our available homes today and unlock the door to your new oasis in the heart of the city.",
  "property_gallery_blurb": "At Cross Timber in Oklahoma City, luxurious living meets convenience. Picture yourself basking in the sun by the pool, or enjoying a vibrant event in our clubhouse. With spacious two and three-bedroom floor plans, modern amenities, and a pet-friendly dog park, your ideal lifestyle awaits—ready for you to step inside!",
  "property_interactivemap_blurb": "Welcome to Cross Timber in the heart of Oklahoma City, where spacious two and three-bedroom apartments redefine comfort. With premium amenities like a refreshing pool, modern fitness center, and vibrant clubhouse, you’re destined to thrive. Let our interactive community map guide you to your perfect home today!",
  "property_pets_blurb": "At Cross Timber in Oklahoma City, indulge in a vibrant community where comfort meets convenience. Our spacious apartments, designed with modern finishes, provide the perfect sanctuary. Plus, your furry friends can thrive here too—bring your pets along (up to 80 lbs) and enjoy life together in our inviting, pet-friendly environment.",
  "property_referafriend_blurb": "At Cross Timber in Oklahoma City, your next adventure awaits! Choose from spacious two and three-bedroom floor plans designed for comfort and style. Plus, bring a friend along—great friends make great neighbors! Refer a friend today and share the joy of living in our vibrant community.",
  "property_residentaccess_blurb": "Welcome to Cross Timber in Oklahoma City, where your comfort is our priority! Choose from our spacious two and three-bedroom floor plans tailored for your lifestyle. Ready for convenient living? Access your resident portal now to pay rent, schedule maintenance, and enjoy the seamless experience you deserve!",
  "property_reviews_blurb": "Nestled in the heart of Oklahoma City, Cross Timber shines with top-notch reviews from our happy residents. With a clean and quiet environment, one resident notes, “I have lived here for 2 years now... it’s fantastic.” Enjoy exceptional management, spacious apartments, and convenient amenities that make coming home a delight. ",
  "property_created_at": "1753982382690",
  "property_scheduletour_blurb": "At Cross Timber in Oklahoma City, experience spacious living with thoughtfully designed two and three-bedroom floor plans. Embrace a vibrant community that prioritizes your comfort. Curious about life here? Schedule a tour today and hear firsthand from our residents about their enriching experiences! Your new home awaits!",
  "property_thankyou_blurb": "Thank you for reaching out to Cross Timber in Oklahoma City! Our spacious two and three-bedroom floor plans offer the perfect blend of comfort and style. Stay tuned as our team connects with you soon to help you find your ideal living space. Exciting times are ahead!",
  "property_virtualtours_blurb": "Welcome to Cross Timber in Oklahoma City, where spacious two and three-bedroom floor plans embrace modern living. Experience our vibrant community through an immersive virtual tour and envision your new home amidst lush landscapes and inviting amenities. Your ideal apartment awaits—step inside today!",
  "property_copyright": "2025 All Rights Reserved. Cross Timber",
  "property_seo_title_home": "Cross Timber |  Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_home": "Experience luxury at Cross Timber in Oklahoma City! Enjoy spacious two and three-bedroom apartments with amazing amenities, from a pool to a dog park. Join us!",
  "property_seo_title_floorplans": "Floor Plans | Oklahoma City, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Cross Timber in Oklahoma City! Browse our unique two and three-bedroom floor plans tailored for comfort and style.",
  "property_seo_title_amenities": "Amenities | Oklahoma City, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Experience elevated living at Cross Timber, OKC! Enjoy resort-style amenities and spacious floor plans. Your ideal home awaits—start today!",
  "property_seo_title_gallery": "Gallery | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_gallery": "Capture your dream lifestyle at Cross Timber in Oklahoma City! Enjoy spacious apartments with resort-style amenities. Picture your new life here!",
  "property_seo_title_virtualtours": "Virtual Tours | Cross Timber Apartments",
  "property_seo_description_virtualtours": "Experience Cross Timber in Oklahoma City—take a virtual tour of our spacious two and three-bedroom apartments designed for your comfort and lifestyle!",
  "property_seo_title_interactivemap": "Interactive Map | Cross Timber Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Cross Timber in OKC! Enjoy spacious 2-3 bedrooms, fantastic amenities, and an interactive map to browse available apartments today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_neighborhood": "Experience the vibrant charm of Cross Timber in Oklahoma City. Uncover local favorites and hidden gems just steps from your new home. Your community awaits!",
  "property_seo_title_contact": "Contact Us | Cross Timber",
  "property_seo_description_contact": "Reach out to our leasing team at Cross Timber in Oklahoma City. Your ideal two or three-bedroom apartment is just a message away. Let's connect today!",
  "property_seo_title_faqs": "FAQs | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_faqs": "Discover answers about Cross Timber in OKC! Our FAQs cover amenities, floor plans, and more to help you find your future home easily.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_reviews": "Experience life at Cross Timber in Oklahoma City—where spacious layouts, top-notch amenities, and a vibrant community await. See what our residents love!",
  "property_seo_title_applynow": "Apply Now | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_applynow": "Discover your haven at Cross Timber, OKC! Spacious 2-3 bedroom apartments with great amenities. Lease online today to elevate your lifestyle!",
  "property_seo_title_residentaccess": "Resident Access | Cross Timber",
  "property_seo_description_residentaccess": "Seamlessly manage your home at Cross Timber in OKC. Log in to your resident portal for easy rent payments, maintenance requests, and community updates!",
  "property_seo_title_referafriend": "Refer A Friend | Cross Timber",
  "property_seo_description_referafriend": "Share the love at Cross Timber! Refer a friend in Oklahoma City and enjoy friendly neighbors and a vibrant community. Join us in creating lasting connections!",
  "property_seo_title_scheduletour": "Schedule a Tour | Cross Timber",
  "property_seo_description_scheduletour": "Explore Cross Timber in Oklahoma City! Schedule your tour today and discover your future home with modern comforts and vibrant community living!",
  "property_seo_title_privacy": "Privacy Policy | Cross Timber",
  "property_seo_description_privacy": "At Cross Timber in OKC, your privacy matters. Discover how we protect your information and enjoy peace of mind in your new home!",
  "property_seo_title_accessibility": "Website Accessibility | Cross Timber",
  "property_seo_description_accessibility": "At Cross Timber in Oklahoma City, we prioritize accessibility for all. Join us in fostering a community where everyone can thrive and connect digitally!",
  "property_seo_title_sitemap": "Sitemap | Cross Timber",
  "property_seo_description_sitemap": "Navigate your way to your perfect home at Cross Timber in Oklahoma City. Check out our sitemap for easy access to all our community's offerings!",
  "property_seo_title_thankyou": "Thank You | Cross Timber",
  "property_seo_description_thankyou": "Thank you for reaching out to Cross Timber in Oklahoma City! A team member will be in touch soon to help you find your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Oklahoma City, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865155431",
  "amenities": [
    {
      "id": "ec_88cc9a7d799266bdd60d9818",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "yardi",
      "external_id": "127396522",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_afad2fe9f971e15037a2d600",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "yardi",
      "external_id": "127396523",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ace783812953dda863793626",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "yardi",
      "external_id": "127396524",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_189cbeb3548b30ff5f6fad36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "yardi",
      "external_id": "127396525",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3eb3a86dae7489dc233397b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "yardi",
      "external_id": "127396526",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bcfb5ba0698a34d7758c14d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "yardi",
      "external_id": "127396527",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_287db486be0504307ff92e6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "yardi",
      "external_id": "128017314",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_973d3d29a22035fd20a441c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "yardi",
      "external_id": "128042529",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3d18d7c8ea302c30f0ce75ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "yardi",
      "external_id": "127397999",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0b0bbb5bf30aeb135fc6b03c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "yardi",
      "external_id": "127398000",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a4784496c75ac8096a56febf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "yardi",
      "external_id": "127398001",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2ad836971386eb1be4a2cf67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "yardi",
      "external_id": "127398002",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51f558089fe35a6d55b46800",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "yardi",
      "external_id": "127398005",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_170ae60667f47419d152792e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "yardi",
      "external_id": "127398006",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_004d3186282453adce328682",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "yardi",
      "external_id": "127398007",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a492c9d177bc9c78c2f0585a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "yardi",
      "external_id": "127398008",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_a5bf7706-fc85-4307-a3d4-2fd2f6f16f2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-871d-7600-a4dc-5314152086c3.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick apartment community building with front entrance and landscaping.",
        "public_id": "019d2708-871d-7600-a4dc-5314152086c3",
        "storage_key": "property/6767906449165600/019d2708-871d-7600-a4dc-5314152086c3.webp",
        "width": 1280,
        "height": 1024
      },
      "title": "Community",
      "description": "Exterior view of a modern brick apartment community with a welcoming front entrance and landscaped surroundings.",
      "link": "",
      "alt_text": "Exterior view of a brick apartment community building with front entrance and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3e-5bc3-7606-a39a-bd16f3a90d34.webp"
    },
    {
      "id": "custom_2b8d6411-4a63-4aaf-8aa9-a65916084b62",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-872f-774b-9dc8-3f6b43949e0c.webp",
      "image_media": {
        "alt_text": "Exterior brick monument sign reading 'Cross Timber Apartment Homes' with ornamental grasses around.",
        "public_id": "019d2708-872f-774b-9dc8-3f6b43949e0c",
        "storage_key": "property/6767906449165600/019d2708-872f-774b-9dc8-3f6b43949e0c.webp",
        "width": 1280,
        "height": 1024
      },
      "title": "Community",
      "description": "Exterior sign at Cross Timber Apartment Homes with landscaping, marking the community entrance.",
      "link": "",
      "alt_text": "Exterior brick monument sign reading 'Cross Timber Apartment Homes' with ornamental grasses around.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3e-5b65-73ad-bda3-ef2532c11a34.webp"
    },
    {
      "id": "custom_d1d54b97-50ed-4c56-8678-fe13d18cfffa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-8712-76aa-8778-eea4aae5c903.webp",
      "image_media": {
        "alt_text": "Row of apartment townhomes with brick and green siding, grills, and a grassy courtyard.",
        "public_id": "019d2708-8712-76aa-8778-eea4aae5c903",
        "storage_key": "property/6767906449165600/019d2708-8712-76aa-8778-eea4aae5c903.webp",
        "width": 1280,
        "height": 1024
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment community with brick accents, green siding, grilling stations, and manicured lawns.",
      "link": "",
      "alt_text": "Row of apartment townhomes with brick and green siding, grills, and a grassy courtyard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3e-5b8c-7428-94f3-35755ebe2554.webp"
    },
    {
      "id": "custom_0b7c3b42-0c28-44eb-91de-004f10cd0f61",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-8728-704a-af1a-c988becc0318.webp",
      "image_media": {
        "alt_text": "Sign reads 'Welcome to Barking Timbers Pet Friendly Park' near a fenced playground.",
        "public_id": "019d2708-8728-704a-af1a-c988becc0318",
        "storage_key": "property/6767906449165600/019d2708-8728-704a-af1a-c988becc0318.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Outdoor pet-friendly park at the community, featuring a fenced playground and bright equipment.",
      "link": "",
      "alt_text": "Sign reads 'Welcome to Barking Timbers Pet Friendly Park' near a fenced playground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3e-6ab5-7325-922e-5309b9af3271.webp"
    },
    {
      "id": "custom_7554e1bf-20fd-4d8f-91e9-821c6f55b329",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-92a8-767a-b452-4ecc616f136f.webp",
      "image_media": {
        "alt_text": "Outdoor community pool with blue water, metal handrail, and surrounding residential buildings.",
        "public_id": "019d2708-92a8-767a-b452-4ecc616f136f",
        "storage_key": "property/6767906449165600/019d2708-92a8-767a-b452-4ecc616f136f.webp",
        "width": 1600,
        "height": 1280
      },
      "title": "Community",
      "description": "Outdoor pool at the apartment community, featuring a fenced area and background residential buildings under a clear sky.",
      "link": "",
      "alt_text": "Outdoor community pool with blue water, metal handrail, and surrounding residential buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165600/019cfb3e-af5e-743d-9185-d3bbf3506f59.webp"
    },
    {
      "id": "custom_0a285bc0-b7ae-4ac1-a22f-3f8ca775cd33",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-960e-7166-b31d-099da66b9605.webp",
      "image_media": {
        "alt_text": "Open-concept community lounge with a large sectional, TV, fireplace, and kitchen island.",
        "public_id": "019d2708-960e-7166-b31d-099da66b9605",
        "storage_key": "property/6767906449165600/019d2708-960e-7166-b31d-099da66b9605.webp",
        "width": 1600,
        "height": 1280
      },
      "title": "Community",
      "description": "Modern communal living area in a multifamily property, showcasing a spacious lounge, television, fireplace, and kitchen island.",
      "link": "",
      "alt_text": "Open-concept community lounge with a large sectional, TV, fireplace, and kitchen island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165600/019cfb3e-b90f-774c-aeb6-96f8ed5a287d.webp"
    },
    {
      "id": "custom_9516eaf3-7927-4c82-b85c-634a19752268",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-9f0b-733b-a63b-88442a5d9640.webp",
      "image_media": {
        "alt_text": "On-site fitness center with treadmills, weight machine, and exercise balls.",
        "public_id": "019d2708-9f0b-733b-a63b-88442a5d9640",
        "storage_key": "property/6767906449165600/019d2708-9f0b-733b-a63b-88442a5d9640.webp",
        "width": 1600,
        "height": 1280
      },
      "title": "Community",
      "description": "Well-equipped resident gym with cardio machines, a multi-gym, free weights, and stability balls.",
      "link": "",
      "alt_text": "On-site fitness center with treadmills, weight machine, and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165600/019cfb3e-bbb8-7471-a21e-997608530c28.webp"
    },
    {
      "id": "custom_06353d18-253e-4f29-b376-f52f8a547e99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-9fcd-7018-823b-1f14948dcf9e.webp",
      "image_media": {
        "alt_text": "Interior of a community gym with treadmills, ellipticals, weight machines and a wall-mounted TV.",
        "public_id": "019d2708-9fcd-7018-823b-1f14948dcf9e",
        "storage_key": "property/6767906449165600/019d2708-9fcd-7018-823b-1f14948dcf9e.webp",
        "width": 1280,
        "height": 1024
      },
      "title": "Community",
      "description": "Well-equipped on-site fitness center with cardio and strength equipment for resident workouts.",
      "link": "",
      "alt_text": "Interior of a community gym with treadmills, ellipticals, weight machines and a wall-mounted TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3e-6a49-7156-91f5-1e3ec7986d78.webp"
    },
    {
      "id": "custom_266891f8-7682-477e-8683-06d7c645b558",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-a111-711c-a217-320eb6d95557.webp",
      "image_media": {
        "alt_text": "Bright apartment living room with a gray sectional, dining area by windows, wall TV, and fireplace.",
        "public_id": "019d2708-a111-711c-a217-320eb6d95557",
        "storage_key": "property/6767906449165600/019d2708-a111-711c-a217-320eb6d95557.webp",
        "width": 1280,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious open-concept living room in a modern apartment featuring a gray sectional, dining area, and a sleek fireplace.",
      "link": "",
      "alt_text": "Bright apartment living room with a gray sectional, dining area by windows, wall TV, and fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3e-6d85-700e-b7cc-6acb12b274be.webp"
    },
    {
      "id": "custom_e1f0310d-423a-4788-920e-c08053683fb9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-a19e-741d-b82f-4b1ff3d8b3b1.webp",
      "image_media": {
        "alt_text": "Open-concept living area with a gray sectional sofa, round wooden table, and modern kitchen in the background.",
        "public_id": "019d2708-a19e-741d-b82f-4b1ff3d8b3b1",
        "storage_key": "property/6767906449165600/019d2708-a19e-741d-b82f-4b1ff3d8b3b1.webp",
        "width": 1280,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Bright, stylish communal living space with a contemporary kitchen and inviting seating.",
      "link": "",
      "alt_text": "Open-concept living area with a gray sectional sofa, round wooden table, and modern kitchen in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3e-5bd4-71e7-9c8b-736ab1158022.webp"
    },
    {
      "id": "custom_be159fe9-52c2-4dd1-9722-dde6f875b66c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-ab51-7244-b835-b4a32a69b27e.webp",
      "image_media": {
        "alt_text": "Open-concept living room with a white sofa, wall art, and a kitchen with a bar counter.",
        "public_id": "019d2708-ab51-7244-b835-b4a32a69b27e",
        "storage_key": "property/6767906449165600/019d2708-ab51-7244-b835-b4a32a69b27e.webp",
        "width": 1600,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Open-concept apartment living area with a white sofa, art, plants, and a bar-height kitchen peninsula.",
      "link": "",
      "alt_text": "Open-concept living room with a white sofa, wall art, and a kitchen with a bar counter.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165600/019cfb3e-bf12-778c-a1bf-416048f76075.webp"
    },
    {
      "id": "custom_1f5f5ca9-4dba-48aa-9664-3874cfbf05d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-af54-77cf-bb67-b1f2ebbaab1c.webp",
      "image_media": {
        "alt_text": "Cozy bedroom in a modern apartment with a gray upholstered bed, nightstand, and window with sheer white curtains.",
        "public_id": "019d2708-af54-77cf-bb67-b1f2ebbaab1c",
        "storage_key": "property/6767906449165600/019d2708-af54-77cf-bb67-b1f2ebbaab1c.webp",
        "width": 1280,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Furnished bedroom in a multifamily unit featuring a patterned duvet, decorative pillows, and a neutral color palette.",
      "link": "",
      "alt_text": "Cozy bedroom in a modern apartment with a gray upholstered bed, nightstand, and window with sheer white curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3e-5b6a-729a-963d-1862bc0368b0.webp"
    },
    {
      "id": "custom_42b72a49-6e8a-493c-8ae8-f3e8c986e2f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-af63-74f8-bd16-c1ed82ab6849.webp",
      "image_media": {
        "alt_text": "Open-concept living area: white sofa, two round wood coffee tables, and a nearby kitchen with white cabinets.",
        "public_id": "019d2708-af63-74f8-bd16-c1ed82ab6849",
        "storage_key": "property/6767906449165600/019d2708-af63-74f8-bd16-c1ed82ab6849.webp",
        "width": 1280,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Bright, modern apartment living area with open kitchen and minimalist decor.",
      "link": "",
      "alt_text": "Open-concept living area: white sofa, two round wood coffee tables, and a nearby kitchen with white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3e-614b-762b-83ec-3da1fd00ee26.webp"
    },
    {
      "id": "custom_70a7a159-48d0-4628-8c31-c58ff9cc61c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-afd4-77fd-86ba-306b8097977c.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with white cabinets, an island, and black appliances.",
        "public_id": "019d2708-afd4-77fd-86ba-306b8097977c",
        "storage_key": "property/6767906449165600/019d2708-afd4-77fd-86ba-306b8097977c.webp",
        "width": 1280,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Bright, modern kitchen in a stylish apartment with white cabinetry, a large island, and stainless steel appliances.",
      "link": "",
      "alt_text": "Modern apartment kitchen with white cabinets, an island, and black appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3e-5b7e-77ec-869a-7511274e68f8.webp"
    },
    {
      "id": "custom_f0e08014-d086-49ee-b4ee-7e2a38193c71",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-b7ae-73e6-ab14-27adfa8da45d.webp",
      "image_media": {
        "alt_text": "Modern apartment bathroom with a double-sink vanity, toilet, and bathtub.",
        "public_id": "019d2708-b7ae-73e6-ab14-27adfa8da45d",
        "storage_key": "property/6767906449165600/019d2708-b7ae-73e6-ab14-27adfa8da45d.webp",
        "width": 1280,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Bright, stylish bathroom in a contemporary apartment featuring a white vanity, decorative wall art, and neutral wood-look flooring.",
      "link": "",
      "alt_text": "Modern apartment bathroom with a double-sink vanity, toilet, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3e-6997-7234-a574-28b5b916a6b7.webp"
    },
    {
      "id": "custom_db71d696-1e60-4e01-bd31-efb4d031713a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-bb35-725f-accf-b3fcd22038e1.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with white cabinets, black appliances, and an island sink.",
        "public_id": "019d2708-bb35-725f-accf-b3fcd22038e1",
        "storage_key": "property/6767906449165600/019d2708-bb35-725f-accf-b3fcd22038e1.webp",
        "width": 1280,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Bright, modern apartment kitchen featuring white cabinetry, a stainless sink, black appliances, and a small dining area.",
      "link": "",
      "alt_text": "Modern apartment kitchen with white cabinets, black appliances, and an island sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3e-6c89-7296-be2f-10e43cac2e22.webp"
    },
    {
      "id": "custom_88dd01e1-b43f-49b3-8d1c-16dc758c9597",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-bb2e-738c-b7b6-c68fc25f7529.webp",
      "image_media": {
        "alt_text": "Open-concept living area with a kitchen island, sofa, coffee tables, and a TV.",
        "public_id": "019d2708-bb2e-738c-b7b6-c68fc25f7529",
        "storage_key": "property/6767906449165600/019d2708-bb2e-738c-b7b6-c68fc25f7529.webp",
        "width": 1280,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Bright, modern apartment living area with an open kitchen, bar seating, and contemporary decor.",
      "link": "",
      "alt_text": "Open-concept living area with a kitchen island, sofa, coffee tables, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3e-6d86-7106-a42d-6cd14da0df39.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_a5e8ea46-078c-4c91-9f98-bd6679a998d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "1109 E Interstate 240 Service Rd, Oklahoma City, OK 73149, USA",
      "poi_short_description": "Texas Roadhouse-branded restaurant, known for its hand-cut steaks.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, including NY strip, sirloin, and prime rib, as well as fried pickles, green beans, and rolls. They also highlight the attentive staff, fast service, and fun atmosphere, especially for celebrations.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-d366-7059-9783-4f9951437b54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-d366-7059-9783-4f9951437b54",
        "storage_key": "property/6767906449165600/019d2708-d366-7059-9783-4f9951437b54.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/oklahoma-city-south-i-240?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=13128196108413720888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "35.3922",
      "poi_longitude": "-97.4918158",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-631-8392",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-0dd7-7599-93cc-2fec20247e9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-0dd7-7599-93cc-2fec20247e9b",
        "storage_key": "property/6767906449165600/019d2709-0dd7-7599-93cc-2fec20247e9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN_b1ObMVsocROFmq7824MLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_4167daff-a5fe-467b-8185-50fe07708962",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Taste of China Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "7435 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Buffet spot featuring Chinese staples, pizza and steaks.",
      "poi_long_description": "Diners say this buffet restaurant offers a wide variety of Chinese food, including Mongolian grill, sushi, and hibachi, as well as Mexican and Italian options. They also highlight the fresh food, attentive service, and great value for the price.\n\nSome reviews mention the restaurant can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-d3c5-75b7-96b7-b85a950750c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-d3c5-75b7-96b7-b85a950750c3",
        "storage_key": "property/6767906449165600/019d2708-d3c5-75b7-96b7-b85a950750c3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://tasteofchinarestaurant.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5294159430709800755&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "taste-of-china-restaurant",
      "poi_latitude": "35.3922925",
      "poi_longitude": "-97.5309638",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-631-1688",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-0dd7-7599-93cc-2fec20247e9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-0dd7-7599-93cc-2fec20247e9b",
        "storage_key": "property/6767906449165600/019d2709-0dd7-7599-93cc-2fec20247e9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNXuPCIwTsocRM--92_OheEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_8136067a-2ed5-4fa7-ad36-65444bb73798",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "920 W I-240 Service Road, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Popular fast-food chain known for its chicken sandwiches and waffle fries.",
      "poi_long_description": "People say this fast food restaurant serves delicious sandwiches and a tasty breakfast menu. They also highlight the fast service, friendly staff, and accurate orders.\n\nOther reviews mention the drive-thru can be confusing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-d3d6-7528-9c48-f65d9a906aa8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-d3d6-7528-9c48-f65d9a906aa8",
        "storage_key": "property/6767906449165600/019d2708-d3d6-7528-9c48-f65d9a906aa8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/240-western?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=18248885707953318924&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "35.3905415",
      "poi_longitude": "-97.5313285",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-632-2525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-0dd7-7599-93cc-2fec20247e9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-0dd7-7599-93cc-2fec20247e9b",
        "storage_key": "property/6767906449165600/019d2709-0dd7-7599-93cc-2fec20247e9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPb_qvI4TsocRDKxCWd0QQf0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_cb333f7f-2810-4504-82b6-d77656c5a3e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "1613 W I-240 Service Road, Oklahoma City, OK 73159, USA",
      "poi_short_description": "Chain specializing in fried-chicken meals including combo plates and finger sandwiches, plus dipping sauces.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers. They also highlight the quick drive-thru service and friendly staff.\n\nOther reviews mention the fries can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-d2e5-7789-82d4-ad831b0f81ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-d2e5-7789-82d4-ad831b0f81ee",
        "storage_key": "property/6767906449165600/019d2708-d2e5-7789-82d4-ad831b0f81ee.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/oklahoma-city/1613-w-i-240-service-rd",
      "poi_directions_map_url": "https://maps.google.com/?cid=14573184076024911847&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "35.3920295",
      "poi_longitude": "-97.5458791",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-680-9103",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-0dd7-7599-93cc-2fec20247e9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-0dd7-7599-93cc-2fec20247e9b",
        "storage_key": "property/6767906449165600/019d2709-0dd7-7599-93cc-2fec20247e9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY8jxypUTsocR5xfYgbRZPso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_71d4450e-5d6c-40da-a5df-4adf5a10f866",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Pier 88 Boiling Seafood & Bar OKC",
      "poi_type": "Restaurants",
      "poi_address": "2125 W I-240 Service Road, Oklahoma City, OK 73159, USA",
      "poi_short_description": "Easygoing, seafood-focused chain serving boils, plus oysters, fried eats and cocktails.",
      "poi_long_description": "Diners say this seafood restaurant serves up delicious seafood boils, especially the royal shrimp combo and snow crab legs with Pier 88 sauce. They also highlight the friendly and attentive service, reasonable prices, and fun, messy atmosphere.\n\nSome reviews mention the wait times for food can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-da61-72b9-8818-e85231c07aac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-da61-72b9-8818-e85231c07aac",
        "storage_key": "property/6767906449165600/019d2708-da61-72b9-8818-e85231c07aac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://direct.chownow.com/order/11293/locations/15613?cn_channel=cn_google&utm_source=cn_google&rwg_token=ACgRB3eqAXeIMVerOx8SoiZ5Dl6x51kRswJSTZUvsKyN_h9SZ3UZwTu5SvWdMgdusa5-WDZ_9u21bR-0BNobdxfj6HsA_KjjVg%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16035403566497813150&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pier-88-boiling-seafood--bar-okc",
      "poi_latitude": "35.3920738",
      "poi_longitude": "-97.5492838",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-601-8812",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-0dd7-7599-93cc-2fec20247e9b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-0dd7-7599-93cc-2fec20247e9b",
        "storage_key": "property/6767906449165600/019d2709-0dd7-7599-93cc-2fec20247e9b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtW4L974TsocRnlIio5Uyid4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_e1dc56b0-f0dc-479b-a2ad-a9d52ca9a28d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "World Fresh International Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "10700 S Pennsylvania Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Produce and meat purveyor for Asian ingredients, baked goods and ethnic eats, plus tea.",
      "poi_long_description": "People say this grocery store offers a wide selection of international foods, fresh produce, and a variety of noodles and rice. They also highlight the delicious bakery, restaurants, and the availability of cookware and anime/K-pop merchandise.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-da94-733b-93b2-c6b2eb4f0aff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-da94-733b-93b2-c6b2eb4f0aff",
        "storage_key": "property/6767906449165600/019d2708-da94-733b-93b2-c6b2eb4f0aff.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.worldfreshmarketokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15266477169668212953&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "world-fresh-international-market",
      "poi_latitude": "35.3609259",
      "poi_longitude": "-97.5471485",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-349-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-0e1a-75ca-abd7-6bc555371aa9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-0e1a-75ca-abd7-6bc555371aa9",
        "storage_key": "property/6767906449165600/019d2709-0e1a-75ca-abd7-6bc555371aa9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnVfSKFoTsocR2UivvRls3dM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_aad0fade-eaf1-4676-bb15-919eef9fd224",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "12100 S Pennsylvania Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Grocery store featuring fresh produce and organic options, plus bins of spices, nuts and sweets.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh, organic produce, delicious breads, and high-quality meats. They highlight the store is clean, well-organized, and stocks items not found elsewhere, including gluten-free and vegan options. They also like the friendly, helpful, and informative staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-dc38-7742-a84f-13ce2942dc92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-dc38-7742-a84f-13ce2942dc92",
        "storage_key": "property/6767906449165600/019d2708-dc38-7742-a84f-13ce2942dc92.webp",
        "width": 640,
        "height": 511
      },
      "poi_business_url": "https://www.sprouts.com/store/ok/moore/moore/",
      "poi_directions_map_url": "https://maps.google.com/?cid=463326420679037265&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "35.3469891",
      "poi_longitude": "-97.5466047",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-416-7650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-0e1a-75ca-abd7-6bc555371aa9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-0e1a-75ca-abd7-6bc555371aa9",
        "storage_key": "property/6767906449165600/019d2709-0e1a-75ca-abd7-6bc555371aa9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj9YBcOkTsocRUZGgv-wQbgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d39a6241-2b1d-4b8b-b659-897b7d41cfcf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Crest Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "10601 S May Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Chain grocery outlet supplying produce, baked goods, and sushi, plus self-checkout.",
      "poi_long_description": "People say this grocery store offers fresh produce, a wide selection of items, and a deli department that slices meat and cheese to order. They highlight the competitive prices, good sales, and well-stocked shelves. They also like the clean and spacious layout, and the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-da8b-7764-b920-7acf4dccdca9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-da8b-7764-b920-7acf4dccdca9",
        "storage_key": "property/6767906449165600/019d2708-da8b-7764-b920-7acf4dccdca9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.crestfoodsok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4018949886565178595&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crest-foods",
      "poi_latitude": "35.3622151",
      "poi_longitude": "-97.5680332",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-814-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-0e1a-75ca-abd7-6bc555371aa9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-0e1a-75ca-abd7-6bc555371aa9",
        "storage_key": "property/6767906449165600/019d2709-0e1a-75ca-abd7-6bc555371aa9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwfJhuAITsocR41zQ5qAtxjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c2f00516-b7da-48cf-a2ca-059aa79a6b7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "7400 S Shields Blvd, Oklahoma City, OK 73149, USA",
      "poi_short_description": "Popular home improvement chain featuring tools, appliances, building materials and garden equipment.",
      "poi_long_description": "People say this home improvement store is well-stocked and the staff are helpful, friendly, and eager to guide customers to the products they need. They also highlight the great customer service and good deals and promotions.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-dfd8-749f-89bd-17da5b28dd6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-dfd8-749f-89bd-17da5b28dd6d",
        "storage_key": "property/6767906449165600/019d2708-dfd8-749f-89bd-17da5b28dd6d.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/S-Oklahoma-City/OK/Oklahoma-City/73149/3901?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9319995899506957809&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.3933171",
      "poi_longitude": "-97.5048175",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-631-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-0dd3-70c6-a2a9-132b1de6b86a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-0dd3-70c6-a2a9-132b1de6b86a",
        "storage_key": "property/6767906449165600/019d2709-0dd3-70c6-a2a9-132b1de6b86a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZZnC3msUsocR8Z01IuRGV4E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_2f10848a-553a-4185-a266-2d13726af7e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "FERIA LATINA SUPERMARKET",
      "poi_type": "Shopping & Retail",
      "poi_address": "1645 SW 47th St, Oklahoma City, OK 73119, USA",
      "poi_short_description": "Clean store featuring fresh produce, Latin products and a meat counter.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-e006-70bc-8d08-5a54185c90f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e006-70bc-8d08-5a54185c90f4",
        "storage_key": "property/6767906449165600/019d2708-e006-70bc-8d08-5a54185c90f4.webp",
        "width": 1280,
        "height": 1109
      },
      "poi_business_url": "http://www.laferialatina.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10792659916104350696&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "feria-latina-supermarket",
      "poi_latitude": "35.4185076",
      "poi_longitude": "-97.5470894",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-600-7310",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-0e1a-75ca-abd7-6bc555371aa9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-0e1a-75ca-abd7-6bc555371aa9",
        "storage_key": "property/6767906449165600/019d2709-0e1a-75ca-abd7-6bc555371aa9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL3mF75oRsocR6Dv_AAM7x5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_82772f24-b6fc-450e-a5c7-f316299b409e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Oklahoma City Community College",
      "poi_type": "Education",
      "poi_address": "7777 S May Ave, Oklahoma City, OK 73159, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-e120-7408-bcc0-43fdf5ecae0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e120-7408-bcc0-43fdf5ecae0e",
        "storage_key": "property/6767906449165600/019d2708-e120-7408-bcc0-43fdf5ecae0e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.occc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12663331797127596950&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-city-community-college",
      "poi_latitude": "35.3880406",
      "poi_longitude": "-97.5699184",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-682-1611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-0e44-705d-972b-a6c0e73e86f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-0e44-705d-972b-a6c0e73e86f9",
        "storage_key": "property/6767906449165600/019d2709-0e44-705d-972b-a6c0e73e86f9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq1zRlkwSsocRlguzIC0xva8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c3981caa-ab52-40b2-a131-cae765355239",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Mid-America Christian University",
      "poi_type": "Education",
      "poi_address": "3500 SW 119th St, Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-e1b4-7613-9cc1-b8635d2bb563.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e1b4-7613-9cc1-b8635d2bb563",
        "storage_key": "property/6767906449165600/019d2708-e1b4-7613-9cc1-b8635d2bb563.webp",
        "width": 1280,
        "height": 453
      },
      "poi_business_url": "https://www.macu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1537180270262459685&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mid-america-christian-university",
      "poi_latitude": "35.3477803",
      "poi_longitude": "-97.5784864",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-691-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-0e44-705d-972b-a6c0e73e86f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-0e44-705d-972b-a6c0e73e86f9",
        "storage_key": "property/6767906449165600/019d2709-0e44-705d-972b-a6c0e73e86f9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIw1jLcMSsocRJZ27vE8pVRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8ef92d87-c46e-4d3b-bdcb-8c0422e98615",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Pioneer Library System - Moore Public Library",
      "poi_type": "Education",
      "poi_address": "225 S Howard Ave, Moore, OK 73160, USA",
      "poi_short_description": "Local institution that provides books, DVDs, computers and programs, with an emphasis on children's offerings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-e518-76c4-86a1-d6c0f0f4b613.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e518-76c4-86a1-d6c0f0f4b613",
        "storage_key": "property/6767906449165600/019d2708-e518-76c4-86a1-d6c0f0f4b613.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://pioneerlibrarysystem.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13566280005030728682&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pioneer-library-system---moore-public-library",
      "poi_latitude": "35.3358205",
      "poi_longitude": "-97.4885841",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-793-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-129b-74da-8150-b337c0abc90b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-129b-74da-8150-b337c0abc90b",
        "storage_key": "property/6767906449165600/019d2709-129b-74da-8150-b337c0abc90b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0xg3BdMUsocR6lNXj8kbRbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_552e4efa-e235-4bc4-a351-5ef4b24892ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "2800 S Telephone Rd, Moore, OK 73160, USA",
      "poi_short_description": "Trampoline park and adventure center featuring go-karts, ropes courses and party rooms.",
      "poi_long_description": "People say this amusement park offers a wide variety of attractions, including go-karts, trampolines, and a ball pit, and is a fun place for birthday parties.\n\nOther reviews mention the go-karts can be slow and the dodgeball area can be unsupervised.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-e66d-73bb-95be-cb7b597738b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e66d-73bb-95be-cb7b597738b7",
        "storage_key": "property/6767906449165600/019d2708-e66d-73bb-95be-cb7b597738b7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/oklahoma-moore/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=454199799262834417&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "35.3130452",
      "poi_longitude": "-97.4932574",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-655-5805",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1299-7799-a77e-a72150b02dca",
        "storage_key": "property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcSyRgFtrsocR8W4dnE-kTQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_efb4d652-ec6e-4f4c-9b3a-2abb9c02f11d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "CB Speegle Stadium",
      "poi_type": "Entertainment",
      "poi_address": "698 SW Grand Blvd #600, Oklahoma City, OK 73109, USA",
      "poi_short_description": "High school sports arena with grandstands for football and soccer matches, clean restrooms and a concession stand.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-e742-7479-a5b3-dd4a3fe1c459.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e742-7479-a5b3-dd4a3fe1c459",
        "storage_key": "property/6767906449165600/019d2708-e742-7479-a5b3-dd4a3fe1c459.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://stadiumconnection.com/ok/stadium.php?id=2507",
      "poi_directions_map_url": "https://maps.google.com/?cid=15079213612661253080&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cb-speegle-stadium",
      "poi_latitude": "35.427616",
      "poi_longitude": "-97.5246531",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-1353-7773-a30e-045ff2393cfa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1353-7773-a30e-045ff2393cfa",
        "storage_key": "property/6767906449165600/019d2709-1353-7773-a30e-045ff2393cfa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCYo7K60WsocR2KPoOuMgRNE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_b910ea50-593a-4cfc-977a-bf19831ee335",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "The 99s Museum of Women Pilots",
      "poi_type": "Entertainment",
      "poi_address": "4300 Amelia Earhart Ln, Oklahoma City, OK 73159, USA",
      "poi_short_description": "This museum showcases artifacts & memorabilia related to female aviators from pilots to astronauts.",
      "poi_long_description": "This museum showcases artifacts & memorabilia related to female aviators from pilots to astronauts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-e6ba-707b-b999-ac76d22983ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e6ba-707b-b999-ac76d22983ae",
        "storage_key": "property/6767906449165600/019d2708-e6ba-707b-b999-ac76d22983ae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.museumofwomenpilots.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7374522594407652441&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-99s-museum-of-women-pilots",
      "poi_latitude": "35.40573980000001",
      "poi_longitude": "-97.5975377",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-685-9990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-12e6-762e-9041-e178136e86da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-12e6-762e-9041-e178136e86da",
        "storage_key": "property/6767906449165600/019d2709-12e6-762e-9041-e178136e86da.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJBSL2IBsSsocRWZzCSzqRV2Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_0d1b20d9-cb6f-4d54-9d4d-a61b36d2b69d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Moore Schools Stadium",
      "poi_type": "Entertainment",
      "poi_address": "911 E Main St, Moore, OK 73160, USA",
      "poi_short_description": "High school and semiprofessional football stadium with a track.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-ebe5-7450-9705-fe4cd25b5187.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-ebe5-7450-9705-fe4cd25b5187",
        "storage_key": "property/6767906449165600/019d2708-ebe5-7450-9705-fe4cd25b5187.webp",
        "width": 1233,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10911573051037220494&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "moore-schools-stadium",
      "poi_latitude": "35.3390384",
      "poi_longitude": "-97.4730242",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-1353-7773-a30e-045ff2393cfa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1353-7773-a30e-045ff2393cfa",
        "storage_key": "property/6767906449165600/019d2709-1353-7773-a30e-045ff2393cfa.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsSD0iyYVsocRjn7Mv-CxbZc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_2c76e8e1-ebc1-41c9-8cef-ff68e1789c4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Gaulke Activity Center",
      "poi_type": "Entertainment",
      "poi_address": "3500 SW 119th St, Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-eeb1-7319-ba5a-07fe80a32d54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-eeb1-7319-ba5a-07fe80a32d54",
        "storage_key": "property/6767906449165600/019d2708-eeb1-7319-ba5a-07fe80a32d54.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.macuathletics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16546178182947341416&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gaulke-activity-center",
      "poi_latitude": "35.347681",
      "poi_longitude": "-97.5799029",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1299-7799-a77e-a72150b02dca",
        "storage_key": "property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCSLslVATsocRaATlWGTVn-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_dfdd8bf6-7320-4ef9-9564-a13a64b2aca1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Earlywine Park YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "11801 S May Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Vast gym & fitness center featuring an indoor swimming pool, a kids' play area, and a walking trail.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-ec90-72ef-9a3b-f958ec3e37e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-ec90-72ef-9a3b-f958ec3e37e0",
        "storage_key": "property/6767906449165600/019d2708-ec90-72ef-9a3b-f958ec3e37e0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ymcaokc.org/branches/earlywine-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3511656398763592292&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "earlywine-park-ymca",
      "poi_latitude": "35.349746",
      "poi_longitude": "-97.566403",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-378-0420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1299-7799-a77e-a72150b02dca",
        "storage_key": "property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv7zS1CETsocRZAqInePouzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_aae9ab83-bf0c-4bd0-9564-4706e706cea3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4106 S Western Ave, Oklahoma City, OK 73109, USA",
      "poi_short_description": "Chain fitness center with an indoor pool, a basketball court, a sauna, and a variety of group fitness classes.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including machines, free weights, cardio, basketball court, racketball, swimming pool, hot tub, and sauna, as well as group fitness classes like BodyPump, HIIT, and yoga. They also highlight the friendly and helpful staff, the clean facilities, and the well-maintained equipment.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-ed3a-735d-a480-53318b83a8c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-ed3a-735d-a480-53318b83a8c9",
        "storage_key": "property/6767906449165600/019d2708-ed3a-735d-a480-53318b83a8c9.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://vasafitness.com/locations/ok/oklahoma-city/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=801655575634150052&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "35.4239616",
      "poi_longitude": "-97.5284652",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-992-0210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1299-7799-a77e-a72150b02dca",
        "storage_key": "property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtbC5qVYRsocRpILiqX8NIAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_fa861239-6501-41e4-ae27-72fc097d742c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Four Star Fitness - Moore",
      "poi_type": "Health and Wellness",
      "poi_address": "1219 N Santa Fe Ave, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this fitness center has a great daycare with friendly staff who genuinely like children, and they appreciate the variety of equipment and 24-hour access. They also highlight the welcoming and inclusive atmosphere, with staff who are always smiling and helpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-f18a-76db-a28e-e944d1c0073f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f18a-76db-a28e-e944d1c0073f",
        "storage_key": "property/6767906449165600/019d2708-f18a-76db-a28e-e944d1c0073f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.fourstarfitnessokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11507987364897746889&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "four-star-fitness---moore",
      "poi_latitude": "35.348233",
      "poi_longitude": "-97.5138619",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-237-3740",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1299-7799-a77e-a72150b02dca",
        "storage_key": "property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4hkozQVsocRye9pVImVtJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_d43cd66b-f1a6-4a61-86bd-d26d811fc9e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9118 S Western Ave A, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Bustling national chain gym with standard workout equipment, massage beds and tanning beds.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and a Black Card area with massage chairs and hydro massage. They highlight the clean, well-lit, and organized facility, and the comfortable, judgment-free atmosphere. They also like the friendly and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-f23d-7109-8651-c04a0f1480e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f23d-7109-8651-c04a0f1480e2",
        "storage_key": "property/6767906449165600/019d2708-f23d-7109-8651-c04a0f1480e2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/oklahoma-city-brookwood-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=7943029326332511845&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.3762027",
      "poi_longitude": "-97.5281104",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-237-3709",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1299-7799-a77e-a72150b02dca",
        "storage_key": "property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiQsn6IETsocRZUaPnBZPO24",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5298040e-e715-4f13-b440-817e28350d78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "1020 SW 104th St, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Gym chain offering strength and cardio equipment, as well as tanning and saunas.",
      "poi_long_description": "People say this gym offers a wide variety of modern equipment, including free weights, machines, and cardio options, and has amenities like massage chairs, a sauna, and tanning. They highlight the affordable prices, convenient 24-hour access, and clean facilities. They also like the friendly, helpful, and supportive staff, and the motivating and welcoming environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-f281-7387-b28c-3d6225eaaa79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f281-7387-b28c-3d6225eaaa79",
        "storage_key": "property/6767906449165600/019d2708-f281-7387-b28c-3d6225eaaa79.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://10gym.com/so-oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4025751960966699643&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "35.3623584",
      "poi_longitude": "-97.5337511",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-691-0037",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1299-7799-a77e-a72150b02dca",
        "storage_key": "property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp3Vq12QTsocRe5pAQxRY3jc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8891b70e-31e6-440e-ac7f-870f81545fb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "790 SW 19th St Ste B, Moore, OK 73160, USA",
      "poi_short_description": "Beauty shop selling over 500 brands of cosmetics plus hair and skin-care products.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-f380-719a-9ae4-074c41bebacd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f380-719a-9ae4-074c41bebacd",
        "storage_key": "property/6767906449165600/019d2708-f380-719a-9ae4-074c41bebacd.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/moore-ok-1548",
      "poi_directions_map_url": "https://maps.google.com/?cid=15419934176653925947&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "35.3177824",
      "poi_longitude": "-97.5024523",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-977-1166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1299-7799-a77e-a72150b02dca",
        "storage_key": "property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5-jf2HlrsocRO95cc2-c_tU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_10cd2b71-fcdc-4fd6-9efc-8e1ca6b1673a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Barbershop Fade Fathers",
      "poi_type": "Health and Wellness",
      "poi_address": "8013 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Barber shop in the 240 Plaza Shopping Center offering professional haircuts and beard trims.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-f644-71ad-b898-b884cdb55768.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f644-71ad-b898-b884cdb55768",
        "storage_key": "property/6767906449165600/019d2708-f644-71ad-b898-b884cdb55768.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.fadefathers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12362820288136197204&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "barbershop-fade-fathers",
      "poi_latitude": "35.3863046",
      "poi_longitude": "-97.5304614",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-764-3767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1299-7799-a77e-a72150b02dca",
        "storage_key": "property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBy3H87MTsocRVLRZEI2Pkas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_5b7360d9-39ce-4a9b-9884-f2afa6c53539",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Animal Emergency & Surgical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "931 W I-240 Service Road, Oklahoma City, OK 73139, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-f7ab-70bc-95e2-f2d6d9793b92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f7ab-70bc-95e2-f2d6d9793b92",
        "storage_key": "property/6767906449165600/019d2708-f7ab-70bc-95e2-f2d6d9793b92.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.okcanimalemergency.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3482013980382145679&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "animal-emergency--surgical-center",
      "poi_latitude": "35.3919712",
      "poi_longitude": "-97.531539",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-631-7828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1299-7799-a77e-a72150b02dca",
        "storage_key": "property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ36JJPYwTsocRjyyfQ0SZUjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_44b20882-54e2-4e86-8b93-c69531bab359",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "SpayXperts PLUS, Affordable Vet Care",
      "poi_type": "Health and Wellness",
      "poi_address": "1065 SW 4th St, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-f7e8-767a-9c9f-475349eb5dab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f7e8-767a-9c9f-475349eb5dab",
        "storage_key": "property/6767906449165600/019d2708-f7e8-767a-9c9f-475349eb5dab.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://spayxperts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7918936431623413321&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "spayxperts-plus-affordable-vet-care",
      "poi_latitude": "35.3347434",
      "poi_longitude": "-97.5117721",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-217-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1299-7799-a77e-a72150b02dca",
        "storage_key": "property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE6FqorQUsocRSR7Qbbq25W0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_02151341-59bb-403b-9752-8515d7d6af41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "INTEGRIS Health Southwest Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4401 S Western Ave, Oklahoma City, OK 73109, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-f8a2-70b7-be61-b6eb76de11dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f8a2-70b7-be61-b6eb76de11dd",
        "storage_key": "property/6767906449165600/019d2708-f8a2-70b7-be61-b6eb76de11dd.webp",
        "width": 683,
        "height": 384
      },
      "poi_business_url": "https://integrisok.com/locations/hospital/integris-southwest-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=12771302873382817443&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "integris-health-southwest-medical-center",
      "poi_latitude": "35.4212648",
      "poi_longitude": "-97.5330065",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-636-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-1753-750f-a7e2-49108b9973cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1753-750f-a7e2-49108b9973cf",
        "storage_key": "property/6767906449165600/019d2709-1753-750f-a7e2-49108b9973cf.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ28Mb51YRsocRo47oTkzIPLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_b298deb1-d8b9-419a-aa9c-9c7d69a4e235",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Community Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "3100 SW 89th St, Oklahoma City, OK 73159, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-fb28-74ba-82d0-4d38d2ca8303.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-fb28-74ba-82d0-4d38d2ca8303",
        "storage_key": "property/6767906449165600/019d2708-fb28-74ba-82d0-4d38d2ca8303.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://www.communityhospitalokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9440951255988147333&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "community-hospital",
      "poi_latitude": "35.375543",
      "poi_longitude": "-97.5705919",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-602-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-1753-750f-a7e2-49108b9973cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1753-750f-a7e2-49108b9973cf",
        "storage_key": "property/6767906449165600/019d2709-1753-750f-a7e2-49108b9973cf.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJrVPr9lQSsocRhZTzoiX_BIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_576ef780-40c7-44d8-ab84-9a2eae0371e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Buck Thomas Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1903 NE 12th St, Moore, OK 73160, USA",
      "poi_short_description": "Outdoor space for sports and picnics featuring baseball fields and a playground.",
      "poi_long_description": "Expansive, nearly 130-acre park featuring a playground, fishing, a walking trail & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-fca3-72aa-80ef-abfb43759006.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-fca3-72aa-80ef-abfb43759006",
        "storage_key": "property/6767906449165600/019d2708-fca3-72aa-80ef-abfb43759006.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofmoore.com/departments/parks-recreation/locations-amenities/buck-thomas-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13701592146103086508&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "buck-thomas-park",
      "poi_latitude": "35.3524633",
      "poi_longitude": "-97.4668896",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-793-5090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-182f-74a8-a9ff-32956a9a6098.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-182f-74a8-a9ff-32956a9a6098",
        "storage_key": "property/6767906449165600/019d2709-182f-74a8-a9ff-32956a9a6098.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB31aBTwVsocRrK3BdXbVJb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7aae6366-9626-4462-ac12-7cb8bd47d2de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Little River Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "709 SW 10th St, Moore, OK 73160, USA",
      "poi_short_description": "Family-friendly park with a splash park, a playground and a pirate ship.",
      "poi_long_description": "People say this park offers a fun splash pad with water slides, a playground, and walking trails. They highlight the free admission and the mini water park experience. They also like the plentiful seating and the fenced splash pad.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-fd3c-75c3-a9df-6047b0a1b07f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-fd3c-75c3-a9df-6047b0a1b07f",
        "storage_key": "property/6767906449165600/019d2708-fd3c-75c3-a9df-6047b0a1b07f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofmoore.com/departments/parks-recreation/locations-amenities/little-river-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13309531068765424630&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "little-river-park",
      "poi_latitude": "35.3275656",
      "poi_longitude": "-97.50192",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-793-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-182f-74a8-a9ff-32956a9a6098.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-182f-74a8-a9ff-32956a9a6098",
        "storage_key": "property/6767906449165600/019d2709-182f-74a8-a9ff-32956a9a6098.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1cPHdTZrsocR9svJeP3ztLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4e33d4ff-a4af-491a-a8ba-d21055a07349",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Earlywine Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11600 S Portland Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this golf course offers two great courses and a new clubhouse. They also highlight the affordable food, easy parking, and helpful staff.\n\nOther reviews mention the course conditions can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2708-fe00-758d-83ab-91b901fe6e51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-fe00-758d-83ab-91b901fe6e51",
        "storage_key": "property/6767906449165600/019d2708-fe00-758d-83ab-91b901fe6e51.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.okcgolf.com/earlywine-golf-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=12680274809197614446&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "earlywine-golf-course",
      "poi_latitude": "35.3519648",
      "poi_longitude": "-97.5817358",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-691-1727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-1829-77e8-aeba-8d6344218080.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1829-77e8-aeba-8d6344218080",
        "storage_key": "property/6767906449165600/019d2709-1829-77e8-aeba-8d6344218080.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJj3nZU-4SsocRbtWOiMFi-a8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_68b7dbaa-9b1e-4e89-8b46-534a34a6f7c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Hidden Trails Golf & Country Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6501 S Country Club Dr, Oklahoma City, OK 73159, USA",
      "poi_short_description": "Private golf club for members and their guests, featuring an 18-hole course and eateries (including a brunch buffet) and a bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-00b1-7001-9eb8-bb66519d2fff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-00b1-7001-9eb8-bb66519d2fff",
        "storage_key": "property/6767906449165600/019d2709-00b1-7001-9eb8-bb66519d2fff.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.hiddentrailsokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17407066464756644046&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hidden-trails-golf--country-club",
      "poi_latitude": "35.3998138",
      "poi_longitude": "-97.5529722",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-685-7751",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-1829-77e8-aeba-8d6344218080.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1829-77e8-aeba-8d6344218080",
        "storage_key": "property/6767906449165600/019d2709-1829-77e8-aeba-8d6344218080.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJX39LX8YTsocRzjhvHblSkvE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_55c677cf-630d-4353-bd29-309b66d605b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Woodson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3403 S May Ave, Oklahoma City, OK 73119, USA",
      "poi_short_description": "Sports complex with soccer and football fields, plus a bike path.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-0155-777b-a07f-85647b6df2c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0155-777b-a07f-85647b6df2c9",
        "storage_key": "property/6767906449165600/019d2709-0155-777b-a07f-85647b6df2c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/181/38",
      "poi_directions_map_url": "https://maps.google.com/?cid=16397680169408746892&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodson-park",
      "poi_latitude": "35.4292777",
      "poi_longitude": "-97.5689321",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-182f-74a8-a9ff-32956a9a6098.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-182f-74a8-a9ff-32956a9a6098",
        "storage_key": "property/6767906449165600/019d2709-182f-74a8-a9ff-32956a9a6098.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJXTLwau0RsocRjFUTRjxDkOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7a9c4bca-35a9-4b70-9833-3c82df270a43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Will Rogers International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "7100 Terminal Dr, Oklahoma City, OK 73159, USA",
      "poi_short_description": "Oklahoma City-area airport featuring art & an outdoor garden with a bronze statue of its namesake.",
      "poi_long_description": "People say this airport is small and easy to navigate, with clear signage and quick access to car rentals. They also highlight the clean restrooms, friendly staff, and efficient security process.\n\nOther reviews mention the food options can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-0200-73ee-8288-c63619a30b55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0200-73ee-8288-c63619a30b55",
        "storage_key": "property/6767906449165600/019d2709-0200-73ee-8288-c63619a30b55.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flyokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14888269631623114364&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "will-rogers-international-airport",
      "poi_latitude": "35.3888421",
      "poi_longitude": "-97.6001183",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-316-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-1825-751a-ae50-d7b4d7a8d8dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1825-751a-ae50-d7b4d7a8d8dc",
        "storage_key": "property/6767906449165600/019d2709-1825-751a-ae50-d7b4d7a8d8dc.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3X8qew0SsocRfK4hOVnCnc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_07bf8172-d6e0-46c9-a95a-811b8de381fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Simple Modern Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "750 SW 24th St Suite 300, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-0292-763c-b1a7-0ba8d87f0833.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0292-763c-b1a7-0ba8d87f0833",
        "storage_key": "property/6767906449165600/019d2709-0292-763c-b1a7-0ba8d87f0833.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "http://simplemodern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5364504164759517206&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "simple-modern-headquarters",
      "poi_latitude": "35.3164404",
      "poi_longitude": "-97.5021957",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1299-7799-a77e-a72150b02dca",
        "storage_key": "property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfe83ix9rsocRFjiYkB2Mcko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9b63eab5-ba1d-4703-b4f7-256dc04ba53c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Integrated Power Services (IPS) - Norman",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6707 N Interstate Dr, Norman, OK 73069, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-071c-746e-bdc4-b9dc75640514.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-071c-746e-bdc4-b9dc75640514",
        "storage_key": "property/6767906449165600/019d2709-071c-746e-bdc4-b9dc75640514.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://ips.us/location/evans-norman/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2485684183795281028&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "integrated-power-services-ips---norman",
      "poi_latitude": "35.2991008",
      "poi_longitude": "-97.4888055",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-631-1344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1299-7799-a77e-a72150b02dca",
        "storage_key": "property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqenS6wRrsocRhKzsbpjsfiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e72442c9-cd8f-4187-b293-3dc7636a3401",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "WFEC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3000 S Telephone Rd, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-0782-748d-9847-43364ba08324.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0782-748d-9847-43364ba08324",
        "storage_key": "property/6767906449165600/019d2709-0782-748d-9847-43364ba08324.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wfec.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11816483374180755416&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wfec",
      "poi_latitude": "35.31055600000001",
      "poi_longitude": "-97.4938519",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-759-2620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1299-7799-a77e-a72150b02dca",
        "storage_key": "property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-U_1KhZrsocR2GdavAWV_KM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_05d44bf1-5805-4ebc-92f3-1d292b811030",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Williamson Farms Clubhouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4908 SW 124th St, Oklahoma City, OK 73173, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-081f-7650-a470-c3f3d6ac9d26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-081f-7650-a470-c3f3d6ac9d26",
        "storage_key": "property/6767906449165600/019d2709-081f-7650-a470-c3f3d6ac9d26.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.wfokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7645727773267508299&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "williamson-farms-clubhouse",
      "poi_latitude": "35.3437351",
      "poi_longitude": "-97.6064228",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1299-7799-a77e-a72150b02dca",
        "storage_key": "property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ0ZrWqESsocRS7zypuYUG2o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f365530c-8459-46c0-86e1-0d576e111f27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Gaming Capital Group",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 NW 32nd St, Newcastle, OK 73065, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://gamingcapitalgroup.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3672858044699103543&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gaming-capital-group",
      "poi_latitude": "35.2893408",
      "poi_longitude": "-97.6046365",
      "poi_miles_from_property": "41.6",
      "poi_walking_minutes": "15 hours 5 mins",
      "poi_biking_minutes": "2 hours 11 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-392-5474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1299-7799-a77e-a72150b02dca",
        "storage_key": "property/6767906449165600/019d2709-1299-7799-a77e-a72150b02dca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqQrxnHttsocRN9G5mO6c-DI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cf98fe68-f2b3-4f9f-a572-9b66c54fb0d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Fisher Elementary School",
      "poi_type": "Education",
      "poi_address": "11800 Southwood Dr, Moore, OK 73170, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://fisher.mooreschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9215563695869784957&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fisher-elementary-school",
      "poi_latitude": "35.35050140000001",
      "poi_longitude": "-97.5583879",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-735-4180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-018a-73cc-a569-c30520c434f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-018a-73cc-a569-c30520c434f2",
        "storage_key": "property/6767906449165600/019cfb3f-018a-73cc-a569-c30520c434f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-2IQnSITsocRffNN8VpC5H8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d6ccfd27-2517-4d4a-b59d-32b5decf1e4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Brink Junior High School",
      "poi_type": "Education",
      "poi_address": "11420 S Western Ave, Moore, OK 73170, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://brinkjh.mooreschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15933095597142122373&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "brink-junior-high-school",
      "poi_latitude": "35.35359",
      "poi_longitude": "-97.5284473",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-735-4540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-018a-73cc-a569-c30520c434f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-018a-73cc-a569-c30520c434f2",
        "storage_key": "property/6767906449165600/019cfb3f-018a-73cc-a569-c30520c434f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1-9WtGATsocRhR__Rwe6Hd0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_fc650b0b-b0cc-464e-ab4d-a05a50123af2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Westmoore High School",
      "poi_type": "Education",
      "poi_address": "12613 S Western Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-2987-71be-b549-fc89739ba49f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2987-71be-b549-fc89739ba49f",
        "storage_key": "property/6767906449165600/019d7912-2987-71be-b549-fc89739ba49f.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://westmoorehs.mooreschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9023050078341389623&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "westmoore-high-school",
      "poi_latitude": "35.3424114",
      "poi_longitude": "-97.5342346",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-735-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-018a-73cc-a569-c30520c434f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-018a-73cc-a569-c30520c434f2",
        "storage_key": "property/6767906449165600/019cfb3f-018a-73cc-a569-c30520c434f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvaTAo1oTsocRN10Zdj1QOH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_6a1df93a-fa68-4de1-9f40-d82d9191ca62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Casady School",
      "poi_type": "Education",
      "poi_address": "9500 N Pennsylvania Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-28d3-72b0-aa21-91e440088349.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-28d3-72b0-aa21-91e440088349",
        "storage_key": "property/6767906449165600/019d7912-28d3-72b0-aa21-91e440088349.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.casady.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9825637108673764104&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "casady-school",
      "poi_latitude": "35.568469",
      "poi_longitude": "-97.546406",
      "poi_miles_from_property": "15.3 mi",
      "poi_walking_minutes": "5 hours 42 mins",
      "poi_biking_minutes": "1 hour 26 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 405-749-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-018a-73cc-a569-c30520c434f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-018a-73cc-a569-c30520c434f2",
        "storage_key": "property/6767906449165600/019cfb3f-018a-73cc-a569-c30520c434f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP8HoKJUbsocRCFtlUuSsW4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_ecd3bd96-b209-4b8d-bb41-0ebbca4a319a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Oklahoma City University",
      "poi_type": "Education",
      "poi_address": "2501 N Blackwelder Ave, Oklahoma City, OK 73106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-2853-7181-b3ff-17abed1377f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2853-7181-b3ff-17abed1377f9",
        "storage_key": "property/6767906449165600/019d7912-2853-7181-b3ff-17abed1377f9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.okcu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=411899583880737593&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-university",
      "poi_latitude": "35.4954082",
      "poi_longitude": "-97.540768",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 405-208-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-018a-73cc-a569-c30520c434f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-018a-73cc-a569-c30520c434f2",
        "storage_key": "property/6767906449165600/019cfb3f-018a-73cc-a569-c30520c434f2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe7zZY6MQsocRObNXPH1ctwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e0c0fbef-0b78-41eb-b40a-7f333396ead6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Pub W",
      "poi_type": "Restaurants",
      "poi_address": "10740 S May Ave Ste 101, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Casual, dog-friendly pub specializing in chicken, waffles and cocktails, along with a patio.",
      "poi_long_description": "People say this restaurant serves delicious burgers, craft beers, and elevated pub food, including chicken and brie sandwiches and salmon. They highlight the reasonable prices, fun and inventive cocktails, and happy hour specials. They also like the friendly and attentive staff, and the management's presence.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-2aba-7648-8786-82033d35b957.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2aba-7648-8786-82033d35b957",
        "storage_key": "property/6767906449165600/019d7912-2aba-7648-8786-82033d35b957.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://pubdub.com/locations/pub-w-s-okc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=49800002840558680&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pub-w",
      "poi_latitude": "35.3608845",
      "poi_longitude": "-97.5648566",
      "poi_miles_from_property": "390 ft",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 405-286-6970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-0155-752e-a4d8-eb87448d3cdd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0155-752e-a4d8-eb87448d3cdd",
        "storage_key": "property/6767906449165600/019cfb3f-0155-752e-a4d8-eb87448d3cdd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI-8V2hwTsocRWPwft9bssAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c9b2b377-598a-436f-8528-17152343f4cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "The Simple Brew",
      "poi_type": "Restaurants",
      "poi_address": "251 S Harrah Rd Suite 109, Harrah, OK 73045, USA",
      "poi_short_description": "Relaxed coffee bar featuring sweets and house-roasted brews plus a drive-thru.",
      "poi_long_description": "People say this coffee shop offers amazing frappes, lattes, and teas, as well as muffins and croissants. They highlight the cozy environment with board games and plush chairs, and the fast service. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-328c-72de-83da-5d91950261e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-328c-72de-83da-5d91950261e6",
        "storage_key": "property/6767906449165600/019d7912-328c-72de-83da-5d91950261e6.webp",
        "width": 720,
        "height": 960
      },
      "poi_business_url": "http://www.simplebrewcoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13231468774450310589&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-simple-brew",
      "poi_latitude": "35.4631536",
      "poi_longitude": "-97.1599642",
      "poi_miles_from_property": "28.6 mi",
      "poi_walking_minutes": "10 hours 32 mins",
      "poi_biking_minutes": "2 hours 39 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "+1 405-347-9107",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-ab2e-7330-867b-704068a84b1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-ab2e-7330-867b-704068a84b1f",
        "storage_key": "property/6767906449165600/019d7912-ab2e-7330-867b-704068a84b1f.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ7zZBaF4zsocRva3IPb-en7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_6c7d9d71-d9de-416c-83f7-1bf1fc274030",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Swadley's Bar-B-Q",
      "poi_type": "Restaurants",
      "poi_address": "8317 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Regional chain doling out smoked ribs, brisket & homestyle sides in easygoing surrounds.",
      "poi_long_description": "People say this barbecue restaurant serves tender and juicy ribs, brisket, and pulled pork, as well as delicious sides like okra, sweet beans, and Mexican street corn. They also highlight the friendly and attentive service, and the clean and comfortable dining area.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-3907-72be-9929-c767e76ccd4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3907-72be-9929-c767e76ccd4f",
        "storage_key": "property/6767906449165600/019d7912-3907-72be-9929-c767e76ccd4f.webp",
        "width": 1280,
        "height": 784
      },
      "poi_business_url": "https://swadleysbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9014978757601479406&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "swadley-s-bar-b-q",
      "poi_latitude": "35.3830603",
      "poi_longitude": "-97.5306794",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-759-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-0155-752e-a4d8-eb87448d3cdd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0155-752e-a4d8-eb87448d3cdd",
        "storage_key": "property/6767906449165600/019cfb3f-0155-752e-a4d8-eb87448d3cdd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpb1Ro4ETsocR7kqHqGqjG30",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_01070e2e-9e7d-49bd-812d-8af7f20bde74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "McClintock Saloon & Chop House",
      "poi_type": "Restaurants",
      "poi_address": "2227 Exchange Ave, Oklahoma City, OK 73108, USA",
      "poi_short_description": "Relaxed spot serving steaks, burgers and prime rib alongside cocktails.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, burgers, and chicken fried steak. They also highlight the great atmosphere, with wood and velvet booths, chandeliers, and carvings, and the exceptional whiskey menu.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-38d5-723e-b79e-a44fbaf77d63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-38d5-723e-b79e-a44fbaf77d63",
        "storage_key": "property/6767906449165600/019d7912-38d5-723e-b79e-a44fbaf77d63.webp",
        "width": 538,
        "height": 304
      },
      "poi_business_url": "http://mcclintocksaloon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17151538246475803024&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mcclintock-saloon-chop-house",
      "poi_latitude": "35.4530152",
      "poi_longitude": "-97.5542409",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-232-0151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-0155-752e-a4d8-eb87448d3cdd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0155-752e-a4d8-eb87448d3cdd",
        "storage_key": "property/6767906449165600/019cfb3f-0155-752e-a4d8-eb87448d3cdd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYwT-qxsRsocRkGm3lCmBBu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_83160cfa-23bc-4149-9b32-af419b006220",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "World Fresh Food Hall",
      "poi_type": "Restaurants",
      "poi_address": "Inside World Fresh Market, 10700 S Pennsylvania Ave, Oklahoma City, OK 73170, USA",
      "poi_short_description": "Food court in Chatenay Square with Vietnamese eats, baked goods, Cajun, barbecue, seafood, and a market.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-4ee7-713a-9f8d-325a7e81a75d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4ee7-713a-9f8d-325a7e81a75d",
        "storage_key": "property/6767906449165600/019d7912-4ee7-713a-9f8d-325a7e81a75d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://phonga405.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13767022316358839725&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "world-fresh-food-hall",
      "poi_latitude": "35.3611757",
      "poi_longitude": "-97.5465897",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-548-1402",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-0155-752e-a4d8-eb87448d3cdd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0155-752e-a4d8-eb87448d3cdd",
        "storage_key": "property/6767906449165600/019cfb3f-0155-752e-a4d8-eb87448d3cdd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrS9eIQETsocRra1xHdtJDr8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "food_court"
    },
    {
      "id": "custom_6883cd14-0763-4c90-ac55-985e2ef2075d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Tropical Smoothie Cafe",
      "poi_type": "Restaurants",
      "poi_address": "705 S MacArthur Blvd, Oklahoma City, OK 73128, USA",
      "poi_short_description": "Health-conscious cafe chain featuring a menu of custom smoothies, sandwiches & wraps.",
      "poi_long_description": "People say this juice shop offers delicious smoothies and quesadillas.\n\nOther reviews mention the service can be slow and the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-3f4b-75ba-a491-0d411a39ed86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3f4b-75ba-a491-0d411a39ed86",
        "storage_key": "property/6767906449165600/019d7912-3f4b-75ba-a491-0d411a39ed86.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "https://locations.tropicalsmoothiecafe.com/ok/oklahoma-city/705-s-macarthur-blvd?y_source=1_MTc5MDMwMzMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11734375149630013157&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tropical-smoothie-cafe",
      "poi_latitude": "35.4581198",
      "poi_longitude": "-97.6194589",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-768-3326",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-0155-752e-a4d8-eb87448d3cdd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0155-752e-a4d8-eb87448d3cdd",
        "storage_key": "property/6767906449165600/019cfb3f-0155-752e-a4d8-eb87448d3cdd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe7WUmrUPsocR5T7e9gbg2KI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "juice_shop"
    },
    {
      "id": "custom_250a5497-04f2-4ebf-b173-3ce2d772c544",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "5400 N May Ave, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide variety of products, including groceries and souvenirs. They also highlight the helpful staff and convenient online ordering and drive-up service.\n\nOther reviews mention the phone service can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-4242-70c1-8703-412e6bcf4309.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4242-70c1-8703-412e6bcf4309",
        "storage_key": "property/6767906449165600/019d7912-4242-70c1-8703-412e6bcf4309.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.target.com/sl/oklahoma-city-north/43",
      "poi_directions_map_url": "https://maps.google.com/?cid=2910655809807328334&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "35.5242129",
      "poi_longitude": "-97.5638205",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 18 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-947-6761",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-0162-7729-a2d3-03b51d083195.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0162-7729-a2d3-03b51d083195",
        "storage_key": "property/6767906449165600/019cfb3f-0162-7729-a2d3-03b51d083195.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJv3tSkWAasocRTiT-pgm6ZCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_d5c9d04f-0c81-4068-9495-279a2224d90b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Burlington",
      "poi_type": "Shopping & Retail",
      "poi_address": "7401 S Shields Blvd, Oklahoma City, OK 73149, USA",
      "poi_short_description": "Chain offering mens’ and womens’ clothing, coats, shoes and furniture, plus jewelry.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-496b-71b9-b39e-5192879ded91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-496b-71b9-b39e-5192879ded91",
        "storage_key": "property/6767906449165600/019d7912-496b-71b9-b39e-5192879ded91.webp",
        "width": 488,
        "height": 289
      },
      "poi_business_url": "https://stores.burlington.com/ok/oklahoma-city/487/?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=15349182578507766689&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "burlington",
      "poi_latitude": "35.3932991",
      "poi_longitude": "-97.5096817",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-636-0002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-0162-7729-a2d3-03b51d083195.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0162-7729-a2d3-03b51d083195",
        "storage_key": "property/6767906449165600/019cfb3f-0162-7729-a2d3-03b51d083195.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJpZ837WsUsocRoduRUDtAA9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_6f1ecb6c-a159-4af1-9480-a44cfad0d208",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "2651 S Telephone Rd, Moore, OK 73160, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "People say this warehouse store offers a wide variety of products, including organic and whole foods, hearing aids, and clothing. They highlight the great value, competitive prices, and the availability of a food court with a popular turkey sandwich. They also like the clean, well-stocked store, and the friendly, helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-4e77-7081-89bf-4f19918d61d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4e77-7081-89bf-4f19918d61d7",
        "storage_key": "property/6767906449165600/019d7912-4e77-7081-89bf-4f19918d61d7.webp",
        "width": 1170,
        "height": 878
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/moore-OK-1444.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=2165105340811591480&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "35.3137961",
      "poi_longitude": "-97.4956262",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-300-7661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-0162-7729-a2d3-03b51d083195.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0162-7729-a2d3-03b51d083195",
        "storage_key": "property/6767906449165600/019cfb3f-0162-7729-a2d3-03b51d083195.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJcf_QtJrsocROD9gFNb_Cx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_4dfaf830-4232-4878-be3c-0ea49a298e96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "1409 W I-240 Service Road, Oklahoma City, OK 73159, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "People say this electronics store offers a wide variety of products, including TVs, computers, and appliances. They also highlight the helpful and friendly staff, and the quick service.\n\nOther reviews mention the staff can be unknowledgeable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-52e0-703d-9d41-3f9b782b0229.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-52e0-703d-9d41-3f9b782b0229",
        "storage_key": "property/6767906449165600/019d7912-52e0-703d-9d41-3f9b782b0229.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.bestbuy.com/ok/oklahoma-city/1409-w-i-240-service-rd-219.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=4870080711584477036&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "35.3930792",
      "poi_longitude": "-97.5396767",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-682-7339",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-0162-7729-a2d3-03b51d083195.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0162-7729-a2d3-03b51d083195",
        "storage_key": "property/6767906449165600/019cfb3f-0162-7729-a2d3-03b51d083195.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ4Q-FeZQTsocRbG95uZoAlkM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_48e9cffd-85af-4a06-ad43-4129b8c8e28f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Half Price Books",
      "poi_type": "Shopping & Retail",
      "poi_address": "1449 W I-240 Service Road, Oklahoma City, OK 73159, USA",
      "poi_short_description": "Family-owned chain that sells secondhand books as well as movies & music in various formats.",
      "poi_long_description": "People say this bookstore offers a wide selection of new, used, and rare books, as well as music, movies, toys, and games. They highlight the organized layout, with shelves labeled in subsections, making it easy to find specific genres and topics. They also like the friendly and helpful staff, and the clean and spacious environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-5564-76fd-afa2-f2b3740fdd0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5564-76fd-afa2-f2b3740fdd0a",
        "storage_key": "property/6767906449165600/019d7912-5564-76fd-afa2-f2b3740fdd0a.webp",
        "width": 613,
        "height": 345
      },
      "poi_business_url": "https://www.hpb.com/store?storeid=HPB-110&showMap=true&horizontalView=true&isForm=true&y_source=1_MTExNTQyNS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3100114633008941507&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "half-price-books",
      "poi_latitude": "35.393034",
      "poi_longitude": "-97.542892",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-680-8730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-0162-7729-a2d3-03b51d083195.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0162-7729-a2d3-03b51d083195",
        "storage_key": "property/6767906449165600/019cfb3f-0162-7729-a2d3-03b51d083195.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPb2LhPwVsocRwwl9Z9XRBSs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_aaea3057-2db4-4a22-ae1a-30a66ebf171f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "1433 W I-240 Service Road, Oklahoma City, OK 73159, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "People say this clothing store offers a wide variety of products, including clothing, beauty, and home decor. They also highlight the affordable prices and the quick checkout lines.\n\nOther reviews mention the self-checkout process can be flawed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-5827-711e-9d9b-97583dcb3bf6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5827-711e-9d9b-97583dcb3bf6",
        "storage_key": "property/6767906449165600/019d7912-5827-711e-9d9b-97583dcb3bf6.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10695061796648510263&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "35.3930827",
      "poi_longitude": "-97.5418683",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-686-0868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-0162-7729-a2d3-03b51d083195.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0162-7729-a2d3-03b51d083195",
        "storage_key": "property/6767906449165600/019cfb3f-0162-7729-a2d3-03b51d083195.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVatfIrkTsocRN-MVCAp-bJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_1ee4319c-fbfc-4808-9606-44aa2fc9bd42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Lane Bryant",
      "poi_type": "Shopping & Retail",
      "poi_address": "1423 W I-240 Service Road, Oklahoma City, OK 73159, USA",
      "poi_short_description": "Women's clothing chain with fashionable plus-size clothing, lingerie, shoes & accessories.",
      "poi_long_description": "Women's clothing chain with fashionable plus-size clothing, lingerie, shoes & accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-62de-73b1-a5dc-a3050b017423.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-62de-73b1-a5dc-a3050b017423",
        "storage_key": "property/6767906449165600/019d7912-62de-73b1-a5dc-a3050b017423.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.lanebryant.com/ok/oklahoma-city/1423-west-i-240-service-rd?sid=NS%3AGoogle%3AGMB&y_source=1_MTE3NTU2MTYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2172310363102480363&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lane-bryant",
      "poi_latitude": "35.3930278",
      "poi_longitude": "-97.5408959",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-415-2606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-0162-7729-a2d3-03b51d083195.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0162-7729-a2d3-03b51d083195",
        "storage_key": "property/6767906449165600/019cfb3f-0162-7729-a2d3-03b51d083195.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVatfIrkTsocR64efDsSYJR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_7b5f0274-15ee-403e-a93f-08af332b936f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Clothes Mentor Edmond, OK",
      "poi_type": "Shopping & Retail",
      "poi_address": "3208 S Broadway, Edmond, OK 73013, USA",
      "poi_short_description": "Resale clothing chain stocking pre-owned brand-name apparel, shoes & accessories for women.",
      "poi_long_description": "People say this women's clothing store offers a great selection of trendy, name-brand items at affordable prices.\n\nOther reviews mention the staff can be impolite and the atmosphere can be unwelcoming.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-665a-70ca-a322-8249e3a95a3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-665a-70ca-a322-8249e3a95a3c",
        "storage_key": "property/6767906449165600/019d7912-665a-70ca-a322-8249e3a95a3c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://edmondok.clothesmentor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17968979817729668378&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "clothes-mentor-edmond-ok",
      "poi_latitude": "35.6244354",
      "poi_longitude": "-97.483406",
      "poi_miles_from_property": "21.5 mi",
      "poi_walking_minutes": "7 hours 57 mins",
      "poi_biking_minutes": "2 hours 10 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 405-285-8867",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-0162-7729-a2d3-03b51d083195.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0162-7729-a2d3-03b51d083195",
        "storage_key": "property/6767906449165600/019cfb3f-0162-7729-a2d3-03b51d083195.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJo5_m7OMesocRGrXww_CjXvk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "womens_clothing_store"
    },
    {
      "id": "custom_85ef703d-cd53-415a-859c-bf9a2a26274c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "PetSmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "1417 W I-240 Service Road, Oklahoma City, OK 73159, USA",
      "poi_short_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_long_description": "People say this pet supply store offers a great variety of products and has friendly and helpful staff. They also highlight the clean and well-organized environment, making it easy to find items.\n\nSome reviews mention there can be long wait times.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-6b4e-73fa-b83a-d877d8eeecdb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-6b4e-73fa-b83a-d877d8eeecdb",
        "storage_key": "property/6767906449165600/019d7912-6b4e-73fa-b83a-d877d8eeecdb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.petsmart.com/stores/us/ok/oklahoma-city-store1517.html?utm_source=google&utm_medium=organic&utm_campaign=google-my-business",
      "poi_directions_map_url": "https://maps.google.com/?cid=2233932951780776917&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "petsmart",
      "poi_latitude": "35.39304449999999",
      "poi_longitude": "-97.5399985",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-681-8198",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-0162-7729-a2d3-03b51d083195.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0162-7729-a2d3-03b51d083195",
        "storage_key": "property/6767906449165600/019cfb3f-0162-7729-a2d3-03b51d083195.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxz-qm5MTsocR1dvuCi-GAB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_b6dfd289-7d4f-41e1-acbe-007a933ae570",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "3301 SW 104th St, Oklahoma City, OK 73159, USA",
      "poi_short_description": "Clean department store selling groceries, furniture and electronics alongside clothing and toys.",
      "poi_long_description": "People say this department store offers a wide selection of products, including groceries, household items, and clothing. They also highlight the clean and well-stocked shelves, and the friendly and helpful staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-6e97-749c-92f2-ded6605adacb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-6e97-749c-92f2-ded6605adacb",
        "storage_key": "property/6767906449165600/019d7912-6e97-749c-92f2-ded6605adacb.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/7326-oklahoma-city-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=8958961904860996264&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.3655059",
      "poi_longitude": "-97.5767452",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-300-6584",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-0162-7729-a2d3-03b51d083195.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0162-7729-a2d3-03b51d083195",
        "storage_key": "property/6767906449165600/019cfb3f-0162-7729-a2d3-03b51d083195.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJN8dfN_oSsocRqCJ_x2KgVHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_5bebc855-6efa-4433-a376-2524fbff73f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Museum of Osteology",
      "poi_type": "Entertainment",
      "poi_address": "10301 S Sunnylane Rd, Oklahoma City, OK 73160, USA",
      "poi_short_description": "Unique spot for educational exhibits of 300+ skeletons of many species plus hands-on displays.",
      "poi_long_description": "Visitors say this museum offers a unique experience with a vast collection of skeletons, including animals, humans, and forensic exhibits. They also highlight the friendly and knowledgeable staff, educational value, and engaging scavenger hunts for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-7a39-77b9-88ef-3c54fc85d4db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-7a39-77b9-88ef-3c54fc85d4db",
        "storage_key": "property/6767906449165600/019d7912-7a39-77b9-88ef-3c54fc85d4db.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.skeletonmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9091622308725140297&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "museum-of-osteology",
      "poi_latitude": "35.3648349",
      "poi_longitude": "-97.4418414",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-814-0006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-0178-77eb-97c0-b4bb1fa7b3ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0178-77eb-97c0-b4bb1fa7b3ea",
        "storage_key": "property/6767906449165600/019cfb3f-0178-77eb-97c0-b4bb1fa7b3ea.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ57ahxGMVsocRSSuU_1HuK34",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_799470b4-8bf3-4862-9a54-2b032dd43ae5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Oklahoma City Zoo",
      "poi_type": "Entertainment",
      "poi_address": "2000 Remington Pl, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Zoo with an array of animals, plus walking trails, shows & attractions such as train tours.",
      "poi_long_description": "Visitors say this zoo offers a wide variety of animals, including elephants, giraffes, stingrays, and a petting zoo, with fun activities like giraffe feeding and a splash pad. They also highlight the friendly and helpful staff, the clean and well-maintained facilities, and the affordable prices, especially with discounts for families and military members.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-7ee7-77e0-a995-cee529acd911.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-7ee7-77e0-a995-cee529acd911",
        "storage_key": "property/6767906449165600/019d7912-7ee7-77e0-a995-cee529acd911.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://okczoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5013321368135377402&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-zoo",
      "poi_latitude": "35.5238895",
      "poi_longitude": "-97.4724932",
      "poi_miles_from_property": "15.2 mi",
      "poi_walking_minutes": "5 hours 39 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 405-424-3344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-018a-73cc-a569-caa9931be877.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-018a-73cc-a569-caa9931be877",
        "storage_key": "property/6767906449165600/019cfb3f-018a-73cc-a569-caa9931be877.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_EZ4YPguocR-qGV_DjlkkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_faa43b75-4200-4bfc-97fd-ea116339a199",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Earlywine Park",
      "poi_type": "Entertainment",
      "poi_address": "3033 SW 119th St, Oklahoma City, OK 73170, USA",
      "poi_short_description": "99-acre facility offering golf, tennis courts, sports fields, a playground & a water park.",
      "poi_long_description": "Visitors say this park offers a great walking trail, a clean and spacious pool, and a fun place for kids to play. They also highlight the friendly and attentive staff, and the affordable prices for non-members.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-78d5-746a-a711-3a447ae41719.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-78d5-746a-a711-3a447ae41719",
        "storage_key": "property/6767906449165600/019d7912-78d5-746a-a711-3a447ae41719.webp",
        "width": 1000,
        "height": 629
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/275/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11488186801211006766&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "earlywine-park",
      "poi_latitude": "35.3526604",
      "poi_longitude": "-97.5677868",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-297-3882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-0162-7729-a2d2-ff7ad82ccd95.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0162-7729-a2d2-ff7ad82ccd95",
        "storage_key": "property/6767906449165600/019cfb3f-0162-7729-a2d2-ff7ad82ccd95.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_bKmP-ASsocRLl-DVwc9bp8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e14a2859-5492-4d56-a13b-11cf075c7bc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Oklahoma City National Memorial & Museum",
      "poi_type": "Entertainment",
      "poi_address": "620 N Harvey Ave, Oklahoma City, OK 73102, USA",
      "poi_short_description": "A garden, pool & sculptural memorial commemorating victims of the 1995 Murrah Building bombing.",
      "poi_long_description": "Visitors say this memorial and museum offers a moving experience, honoring the lives lost in the 1995 Oklahoma City bombing. They also highlight the peaceful and serene atmosphere, with many finding it a place for quiet reflection and remembrance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-7cb2-75dd-83ee-539b12a9aae2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-7cb2-75dd-83ee-539b12a9aae2",
        "storage_key": "property/6767906449165600/019d7912-7cb2-75dd-83ee-539b12a9aae2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://memorialmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4635276338053722639&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-national-memorial-museum",
      "poi_latitude": "35.4731496",
      "poi_longitude": "-97.5170593",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 405-235-3313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-0178-77eb-97c0-b4bb1fa7b3ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0178-77eb-97c0-b4bb1fa7b3ea",
        "storage_key": "property/6767906449165600/019cfb3f-0178-77eb-97c0-b4bb1fa7b3ea.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJq81FLi4XsocRDzJ3TUXPU0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_ee1ee45c-6359-4016-8323-57d34098ba59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Scissortail Park",
      "poi_type": "Entertainment",
      "poi_address": "300 SW 7th St, Oklahoma City, OK 73109, USA",
      "poi_short_description": "Lively space including gardens, a lake & playground, also home to a farmers' market & concerts.",
      "poi_long_description": "People say this park offers a variety of activities, including walking trails, a splash pad, a playground, and a ninja course. They highlight the beautiful landscaping, flowers, and views, as well as the fun and family-friendly vibe. They also like the free parking and the availability of food trucks and a farmers market.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-8340-74ef-b9dc-09c2fb26a58d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-8340-74ef-b9dc-09c2fb26a58d",
        "storage_key": "property/6767906449165600/019d7912-8340-74ef-b9dc-09c2fb26a58d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://scissortailpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2532545101640635246&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "scissortail-park",
      "poi_latitude": "35.4596348",
      "poi_longitude": "-97.5176865",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-445-6277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-0162-7729-a2d2-ff7ad82ccd95.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-0162-7729-a2d2-ff7ad82ccd95",
        "storage_key": "property/6767906449165600/019cfb3f-0162-7729-a2d2-ff7ad82ccd95.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5fS8K30XsocRbhPyGFpoJSM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_33aa283e-3b19-415e-91ae-9f3b3d48b3d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Myriad Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "301 W Reno Ave, Oklahoma City, OK 73102, USA",
      "poi_short_description": "A 15-acre facility with formal gardens, a tropical conservatory, a dog park & horticultural classes.",
      "poi_long_description": "People say this botanical garden offers a wide variety of plants, including tropical plants, orchids, and tulips, and features a conservatory, greenhouse, and walking paths. They highlight the beautiful and peaceful atmosphere, perfect for relaxing and taking photos, and the family-friendly amenities, such as a playground, splash pad, and carousel. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-908b-752c-9a24-bdc17aca967b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-908b-752c-9a24-bdc17aca967b",
        "storage_key": "property/6767906449165600/019d7912-908b-752c-9a24-bdc17aca967b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.myriadgardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10363530004578021372&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "myriad-botanical-gardens",
      "poi_latitude": "35.46533110000001",
      "poi_longitude": "-97.5179073",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-445-7080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-018a-73cc-a569-caa9931be877.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-018a-73cc-a569-caa9931be877",
        "storage_key": "property/6767906449165600/019cfb3f-018a-73cc-a569-caa9931be877.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA05XnykXsocR_K_5faGn0o8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_5f83a9e0-a28a-4a11-82fc-f0009ea22557",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Winchester Drive-In",
      "poi_type": "Entertainment",
      "poi_address": "6930 S Western Ave, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Oklahoma City's oldest drive-in movie theater is open seasonally & fits 475 cars.",
      "poi_long_description": "People say this drive-in movie theater offers a double feature, delicious popcorn, and a wide selection of snacks at the snack bar. They highlight the reasonable prices, nostalgic vibe, and fun experience. They also like the friendly, helpful, and attentive staff, and the clean facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-98ff-703f-86e8-b8418a4a1673.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-98ff-703f-86e8-b8418a4a1673",
        "storage_key": "property/6767906449165600/019d7912-98ff-703f-86e8-b8418a4a1673.webp",
        "width": 967,
        "height": 803
      },
      "poi_business_url": "http://www.winchesterdrivein.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13189817087385337736&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "winchester-drive-in",
      "poi_latitude": "35.3959297",
      "poi_longitude": "-97.5273782",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-631-8851",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-ad2d-72d9-be73-b9f10f116563.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-ad2d-72d9-be73-b9f10f116563",
        "storage_key": "property/6767906449165600/019d7912-ad2d-72d9-be73-b9f10f116563.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJWSraI4sTsocRiP_6IcKkC7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_2fee5a13-4330-4f42-8653-b322ef44d8fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Regal Warren Moore",
      "poi_type": "Entertainment",
      "poi_address": "1000 S Telephone Rd, Moore, OK 73160, USA",
      "poi_short_description": "Retro-style multiplex chain showing new releases; some locations feature '40s-style diners & IMAX.",
      "poi_long_description": "People say this movie theater offers a fun 4DX experience, comfortable reclining seats, and fresh popcorn. They also highlight the friendly and helpful staff, and the clean and convenient atmosphere.\n\nOther reviews mention the drinks can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-9b2e-731a-8ee4-94c8aebc50fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-9b2e-731a-8ee4-94c8aebc50fa",
        "storage_key": "property/6767906449165600/019d7912-9b2e-731a-8ee4-94c8aebc50fa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-warren-moore-1447?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=9073693325050595022&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "regal-warren-moore",
      "poi_latitude": "35.3290077",
      "poi_longitude": "-97.4934055",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-ad2d-72d9-be73-b9f10f116563.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-ad2d-72d9-be73-b9f10f116563",
        "storage_key": "property/6767906449165600/019d7912-ad2d-72d9-be73-b9f10f116563.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJn6QzNZtrsocRzkZ5MAE87H0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_feb4c972-302e-4dc5-ae1f-814a897202ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "poi_name": "Hurricane Harbor Oklahoma City",
      "poi_type": "Entertainment",
      "poi_address": "3908 W Reno Ave, Oklahoma City, OK 73107, USA",
      "poi_short_description": "Seasonal water park featuring thrill rides, slides & play pools, plus outdoor movie nights.",
      "poi_long_description": "People say this water park offers a variety of slides and areas to swim and float, providing fun for all ages. They also highlight the all-day drink bottles and unlimited meal deals is a good value, and the staff is generally friendly.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019d7912-9e81-7008-a833-d6c453f3f1da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-9e81-7008-a833-d6c453f3f1da",
        "storage_key": "property/6767906449165600/019d7912-9e81-7008-a833-d6c453f3f1da.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.sixflags.com/hurricaneharborokc",
      "poi_directions_map_url": "https://maps.google.com/?cid=554219685046233621&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hurricane-harbor-oklahoma-city",
      "poi_latitude": "35.4616121",
      "poi_longitude": "-97.5886688",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-943-9687",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-018a-73cc-a569-caa9931be877.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-018a-73cc-a569-caa9931be877",
        "storage_key": "property/6767906449165600/019cfb3f-018a-73cc-a569-caa9931be877.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMa4rXNURsocRFaq1_t37sAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    }
  ],
  "office_hours": [
    {
      "id": "ec_ceadbf78bbbeb214f19ed0aa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_71ddda4567eaa8b8abacec92",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_f2c9bee3c3a7bbc828c361aa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_d842a32466f320fd6807fdd5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_32f98b9a2ab851a1198fc748",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_95ce92b35ed0b0f497bc9e28",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_5cbcf8b7-c9c1-421b-b0f5-02c8b5b1b822",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "rating": "5.0",
      "name": "Clayton Freeman",
      "text": "My wife and I have loved having Cross Timber be our first apartment together. We have enjoyed the space and location. Having somewhere to workout and swim has been nice and a fun thing to do together. The living spaces are not huge, but are perfect for a small family. The staff is kind and helpful. All in all, we have loved our time here!!",
      "date": "2025-07-30",
      "title": ""
    },
    {
      "id": "custom_b26123ca-818b-484c-bbda-ea76a787805e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "rating": "5.0",
      "name": "Kandice Roberts",
      "text": "They have been so kind and so nice with all the things! As a young adult there is many things that I am still learning that go into the process of renting an apartment! They have been so kind and telling me that information and answering all the silly questions! Over all I feel safe here regardless of the time! Mrs. Darlene is so kind and treats everyone as an individual! 10/10 recommend!!",
      "date": "2025-08-19",
      "title": ""
    },
    {
      "id": "custom_c886829d-6e7a-4afa-aa1d-3a2d448bf979",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "rating": "5.0",
      "name": "Bailey Kestner",
      "text": "I love living here! Beautiful and spacious apartments at a very reasonable price in a growing area of the city. The grounds are very clean and safe – I've not had any issues in the last year whatsoever. Darlene and Katrina are amazing apartment managers always willing to help. Maintenance is also quick to respond when needed. I recommend renting here!",
      "date": "2025-07-01",
      "title": ""
    },
    {
      "id": "custom_8b60154a-4e11-48f2-881f-32861eaa1d7d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "rating": "5.0",
      "name": "trevor graham",
      "text": "These apartments are amazing. The office staff is beyond helpful and nice. They treat you like family. Nice and clean apartments.  its a quiet community with friendly neighbors and plenty of parking always. Im happy with my choice of moving here",
      "date": "2025-08-20",
      "title": ""
    },
    {
      "id": "custom_6120eb3f-d85c-411d-91ef-010b7690354c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "rating": "5.0",
      "name": "Amanda King",
      "text": "I absolutely love this apartment complex!! I moved in at the beginning of the year and I can truly say this place feels like home. You have two amazing ladies in the office who are so kind and warm hearted. Finding a complex that genuinely cares seems rare but not here! Even my fur babies love it here, they are living their best life especially with a big living room window to watch all the birds! If I could give this place more than 5 stars I definitely would! The pool is always clean and the landscape is always in perfect condition!",
      "date": "2025-07-30",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_77c4c87f-2995-4b5a-bbce-0c53cc1db72d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3f-9a41-750a-ad32-bbfa29615ac6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 degree view of a modern kitchen with island, refrigerator, and cabinets.",
        "public_id": "019cfb3f-9a41-750a-ad32-bbfa29615ac6",
        "storage_key": "property/6767906449165600/019cfb3f-9a41-750a-ad32-bbfa29615ac6.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Cross Timber Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=618153f6e345b578fcd71b09&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-2c61-71d7-a810-7e1fe400512a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "cross-timber",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600"
    },
    {
      "lead_collector_id": "019cf79e-2cd4-7214-b48b-5b2171b78d48",
      "lead_source": "LANDING_PAGE",
      "name": "cross-timber",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "generator",
      "page_item_url": "apartments-with-in-unit-laundry-oklahoma-city",
      "search_query": "apartments with in-unit laundry Oklahoma City",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in OKC",
      "h2_subtitle": "Discover apartments with in-unit laundry in Oklahoma City. Cross Timber offers spacious options with the convenience you desire.",
      "page_copy": "Experience the ultimate convenience at Cross Timber, where our select apartments boast in-unit laundry facilities, elevating your living experience in Oklahoma City. Our community, located in the welcoming Lakeridge Run neighborhood, offers two and three-bedroom floor plans that provide ample space and modern comfort. Enjoy amenities such as a refreshing pool, state-of-the-art fitness center, and impeccably designed interiors, all in a pet-friendly environment.\n\nAt Cross Timber, you are not just renting an apartment; you are choosing a lifestyle that integrates both luxury and practical amenities. Beyond the in-unit laundry, residents benefit from high-speed internet, large bedrooms, air conditioning, and close proximity to local attractions. Embrace the dynamic blend of comfort and convenience at Cross Timber in Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3e-bf12-778c-a1bf-416048f76075.webp",
      "featured_image_media": {
        "alt_text": "Bright living area with white sofa, coffee table, and open-concept kitchen with bar seating.",
        "public_id": "019cfb3e-bf12-778c-a1bf-416048f76075",
        "storage_key": "property/6767906449165600/019cfb3e-bf12-778c-a1bf-416048f76075.webp",
        "width": 1600,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in OKC",
      "seo_description": "Find apartments with in-unit laundry in Oklahoma City at Cross Timber. Spacious layouts, modern amenities, and prime location in OKC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-dog-park-oklahoma-city",
      "search_query": "pet friendly apartments with dog park in Oklahoma City",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Dog Park",
      "h2_subtitle": "Explore pet-friendly apartments with a dog park in Oklahoma City. Cross Timber offers an ideal living experience for pet owners.",
      "page_copy": "Welcome to Cross Timber, the perfect place for both you and your furry friends in Oklahoma City. Our pet-friendly community features a dedicated dog park, where your pets can run and play, making it an easy choice for animal lovers. Choose from spacious two and three-bedroom apartments equipped with amenities such as a fitness center and a refreshing swimming pool, ensuring a complete lifestyle package.\n\nLocated in the inviting Lakeridge Run area, our apartments provide luxurious living with high-speed internet, large bedrooms, and well-designed interiors. Air-conditioned comfort meets the convenience of a dog park, making Cross Timber a top choice for pet owners in Oklahoma City. Our community isn't just pet-friendly; it's a place where both you and your pets can thrive.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3e-bf12-778c-a1bf-416048f76075.webp",
      "featured_image_media": {
        "alt_text": "Bright living area with white sofa, coffee table, and open-concept kitchen with bar seating.",
        "public_id": "019cfb3e-bf12-778c-a1bf-416048f76075",
        "storage_key": "property/6767906449165600/019cfb3e-bf12-778c-a1bf-416048f76075.webp",
        "width": 1600,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apts with Dog Park in OKC",
      "seo_description": "Choose pet-friendly apartments with a dog park in Oklahoma City at Cross Timber. Ideal for pet owners seeking comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "generator",
      "page_item_url": "luxury-apartments-pool-lakeridge-run",
      "search_query": "luxury apartments with a pool in Lakeridge Run",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Lakeridge Run",
      "h2_subtitle": "Discover luxury apartments with a pool in Lakeridge Run. Cross Timber offers upscale living in a vibrant community.",
      "page_copy": "Experience upscale living at Cross Timber, where luxury meets comfort in the desirable Lakeridge Run neighborhood of Oklahoma City. Our apartments provide access to a sparkling pool, perfect for recreation and relaxation, along with spacious two and three-bedroom layouts that embody modern elegance and sophistication. Each unit is designed with high-end finishes, seamlessly combining style with functionality.\n\nCross Timber offers more than just luxury apartments; it presents a lifestyle enhanced with community-oriented amenities such as a well-equipped fitness center and pet-friendly spaces. Enjoy large bedrooms, high-speed Wi-Fi, and air-conditioned comfort, all located in a peaceful setting. Embrace the serene yet luxurious atmosphere that comes with living at Cross Timber in Lakeridge Run.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3e-bf12-778c-a1bf-416048f76075.webp",
      "featured_image_media": {
        "alt_text": "Bright living area with white sofa, coffee table, and open-concept kitchen with bar seating.",
        "public_id": "019cfb3e-bf12-778c-a1bf-416048f76075",
        "storage_key": "property/6767906449165600/019cfb3e-bf12-778c-a1bf-416048f76075.webp",
        "width": 1600,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apts with Pool in Lakeridge Run",
      "seo_description": "Find luxury apartments with a pool in Lakeridge Run at Cross Timber. Upscale amenities and vibrant community living await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "generator",
      "page_item_url": "dishwasher-equipped-apartments-oklahoma-city",
      "search_query": "dishwasher equipped apartments in Oklahoma City",
      "category": "Amenity",
      "h1_title": "Dishwasher Equipped Apartments in OKC",
      "h2_subtitle": "Find dishwasher equipped apartments in Oklahoma City. Cross Timber offers modern living with convenient amenities.",
      "page_copy": "Discover the convenience of living at Cross Timber, where select apartments come equipped with dishwashers, greatly simplifying your daily routine in Oklahoma City. Nestled in the welcoming Lakeridge Run neighborhood, our spacious two and three-bedroom floor plans are designed with your utmost comfort in mind. In addition to the convenience of in-unit dishwashers, residents enjoy access to luxurious amenities like a sparkling pool and a state-of-the-art fitness center.\n\nCross Timber is more than just a place to live; it's a community that supports a vibrant lifestyle. Large bedrooms, high-speed internet, modern air conditioning, and pet-friendly spaces harmonize to create an ideal living environment. Embrace the seamless blend of comfort and practicality at Cross Timber, right in the heart of Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3e-bf12-778c-a1bf-416048f76075.webp",
      "featured_image_media": {
        "alt_text": "Bright living area with white sofa, coffee table, and open-concept kitchen with bar seating.",
        "public_id": "019cfb3e-bf12-778c-a1bf-416048f76075",
        "storage_key": "property/6767906449165600/019cfb3e-bf12-778c-a1bf-416048f76075.webp",
        "width": 1600,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dishwasher Equipped Apts in OKC",
      "seo_description": "Explore dishwasher equipped apartments in Oklahoma City at Cross Timber. Enjoy modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-73170",
      "search_query": "air conditioned apartments in Zip 73170",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Zip 73170",
      "h2_subtitle": "Locate air conditioned apartments in Zip 73170. Cross Timber offers comfort and modern amenities in a prime Oklahoma City location.",
      "page_copy": "Welcome to Cross Timber, where air-conditioned comfort is standard in our spacious apartment homes located in the 73170 ZIP code of Oklahoma City. Our two and three-bedroom models are equipped with top-tier air conditioning systems, ensuring relief from the summer heat and a pleasant living environment all year round. Situated in the serene Lakeridge Run community, our residents enjoy a blend of modern living with practical amenities.\n\nAt Cross Timber, you'll find more than just air-conditioned apartments. Our community features large bedrooms, high-speed internet, and a sparkling pool for relaxation. The fitness center, together with our dog-friendly spaces, enriches the lifestyle offered here. Choose Cross Timber in 73170 for a harmonious combination of comfort, style, and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3e-bf12-778c-a1bf-416048f76075.webp",
      "featured_image_media": {
        "alt_text": "Bright living area with white sofa, coffee table, and open-concept kitchen with bar seating.",
        "public_id": "019cfb3e-bf12-778c-a1bf-416048f76075",
        "storage_key": "property/6767906449165600/019cfb3e-bf12-778c-a1bf-416048f76075.webp",
        "width": 1600,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apts in Zip 73170",
      "seo_description": "Find air conditioned apartments in Zip 73170 at Cross Timber. Enjoy comfort and modern amenities in Oklahoma City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-oklahoma-city",
      "search_query": "two bedroom apartments in Oklahoma City OK",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Oklahoma City",
      "h2_subtitle": "Discover two bedroom apartments in Oklahoma City. Cross Timber offers spacious layouts with modern amenities.",
      "page_copy": "Explore the spacious two-bedroom apartments at Cross Timber, located in the vibrant Lakeridge Run neighborhood of Oklahoma City, OK. Designed with both style and functionality in mind, our two-bedroom units provide ample living space and premium amenities, including large bedrooms, high-speed Wi-Fi, and efficient air conditioning.\n\nCross Timber isn't just about beautiful interiors; it's a community geared towards enhancing your lifestyle. Residents can relax in the sparkling pool, stay fit in our fully-equipped fitness center, and enjoy the comfort of pet-friendly spaces. Experience the perfect blend of comfort, convenience, and modern living in our two-bedroom apartments in the heart of Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3e-bf12-778c-a1bf-416048f76075.webp",
      "featured_image_media": {
        "alt_text": "Bright living area with white sofa, coffee table, and open-concept kitchen with bar seating.",
        "public_id": "019cfb3e-bf12-778c-a1bf-416048f76075",
        "storage_key": "property/6767906449165600/019cfb3e-bf12-778c-a1bf-416048f76075.webp",
        "width": 1600,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apts in Oklahoma City OK",
      "seo_description": "Find spacious two bedroom apartments in Oklahoma City at Cross Timber. Enjoy modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165600",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-lakeridge-run-ok",
      "search_query": "three bedroom apartments near Lakeridge Run OK",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near Lakeridge Run",
      "h2_subtitle": "Explore three bedroom apartments near Lakeridge Run, OK. Cross Timber offers spacious living and top-notch amenities.",
      "page_copy": "Experience the spacious elegance of three-bedroom apartments at Cross Timber, situated near the desirable Lakeridge Run neighborhood in Oklahoma City, OK. These carefully designed homes provide expansive living spaces along with modern comforts like large bedrooms and efficient air conditioning, perfect for accommodating families or those needing extra room.\n\nLiving at Cross Timber means access to exceptional community amenities, such as a sparkling pool for relaxation, a fitness center for health enthusiasts, and pet-friendly spaces for your furry companions. Conveniently located near the heart of Oklahoma City, our three-bedroom offerings promise an unmatched blend of comfort and lifestyle. Choose Cross Timber for the ideal setting to call home near Lakeridge Run.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165600/019cfb3e-bf12-778c-a1bf-416048f76075.webp",
      "featured_image_media": {
        "alt_text": "Bright living area with white sofa, coffee table, and open-concept kitchen with bar seating.",
        "public_id": "019cfb3e-bf12-778c-a1bf-416048f76075",
        "storage_key": "property/6767906449165600/019cfb3e-bf12-778c-a1bf-416048f76075.webp",
        "width": 1600,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apts Near Lakeridge Run OK",
      "seo_description": "Find three bedroom apartments near Lakeridge Run, OK, at Cross Timber. Enjoy modern living with spacious layouts and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5169"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-FT61M50FPS"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151489"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/cross-timber/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KFSHVL6G"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165600/019dbc26-e09c-7570-8149-38cba4a5b7b0.webp"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-209-7949"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "69ec04f2ce086d431922581a"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjdHY2NCQ0RhQlN5TU84cFFDQTdYcHc9PSIsInZhbHVlIjoiR3V0Z3Q1OHVuUUM3ZkJwUGhvemtZZz09IiwibWFjIjoiYTk5NjFkNTJkZGY2ZGM2ZGM5Y2JhNzEwM2Q0ZmVmYWM0YjM0MGZmMWEwODRiODk5ZWE2ZmRlOGZiMTcwNzBhNiJ9"
    }
  ],
  "custom_qb_id": "5169",
  "custom_ga4_id": "G-FT61M50FPS",
  "custom_repli_id": "10041151489",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/cross-timber/register/",
  "custom_google_gtm_id": "GTM-KFSHVL6G",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165600/019dbc26-e09c-7570-8149-38cba4a5b7b0.webp",
  "custom_ppc_tracking_phone_number": "844-209-7949",
  "custom_residentboost_apartment_id": "69ec04f2ce086d431922581a",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjdHY2NCQ0RhQlN5TU84cFFDQTdYcHc9PSIsInZhbHVlIjoiR3V0Z3Q1OHVuUUM3ZkJwUGhvemtZZz09IiwibWFjIjoiYTk5NjFkNTJkZGY2ZGM2ZGM5Y2JhNzEwM2Q0ZmVmYWM0YjM0MGZmMWEwODRiODk5ZWE2ZmRlOGZiMTcwNzBhNiJ9"
};

export const generatedAt = '2026-08-27T21:38:35.314Z';
